import axios from "axios";

export const oDocApiCall = (odocID, data) => {
  return axios
    .patch(`${process.env.REACT_APP_ODOC_API}/${odocID}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: process.env.REACT_APP_ODOC_TOKEN,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => console.log("Err", e));
};

export const allActivityTracks = async (params) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_ACTIVITY_TRACKER_HOST}/search`,
      {
        params,
        data: null,
        headers: {
          "Content-Type": "application/json",
          "X-Client-Name": "FLASH",
          Authorization: process.env.REACT_APP_ACTIVITY_TRACKER_TOKEN,
        },
      },
    );
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const allActivityCodes = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_ACTIVITY_TRACKER_HOST}/activity`,
      {
        data: null,
        headers: {
          "Content-Type": "application/json",
          "X-Client-Name": "FLASH",
          Authorization: process.env.REACT_APP_ACTIVITY_TRACKER_TOKEN,
        },
      },
    );
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getInsuredUsers = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/insuranceusers", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getClaimTags = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/get-tags?type=claims", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getFlashCreditTypes = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/flashCredit", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const geFeturedtMedicationcategory = (obj, pg_no) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medicationCategories?page=" +
        pg_no,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getMedicationcategory = (obj, pg_no) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medicationCategories?page=" +
        pg_no,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getProductList = (obj, searchproduct, searchsupplier, number) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        `/medicationList?search_product_values=${searchproduct}&search_supplier_data=${searchsupplier}&page=${number}`,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getCountry = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/countries", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const getInsuaranceCompanyList = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/insuarance_company/list", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const getCustomer = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/users", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const AddMedicationbulkfile = (csv_file, obj) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/medications/import/csv";
  return axios
    .post(
      url,
      {
        csv_file: csv_file,
      },
      {
        headers: {
          "Content-Type": "text/plain ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const AddProductbulkfileUpload = (csv_file, obj, sup_id) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medicationList/import/csv?supplier_id=" +
    sup_id;
  return axios
    .post(
      url,
      {
        csv_file: csv_file,
      },
      {
        headers: {
          "Content-Type": "text/plain ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const exportmedicationfile = (obj) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/medications/export/csv";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "text/plain ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

// export const AddMedicationcategory = (
//   medicationcategoryname,
//   wt_commision,
//   attaced_image,
//   is_featured,
//   obj
// ) => {
//   // console.log(attachments);
//   // console.log(obj,medicationcategoryname,wt_commision);
//   const url = process.env.REACT_APP_NOT_SECRET_CODE + "/medicationCategories";

//   return axios
//     .post(url, fdata, {
//       headers: {
//         "Content-Type": "application/json ",
//         "X-Request-ID": "124",
//         "X-Country-Code": "BD",
//         "X-Client-Name": "WEBSITE",
//         "X-Client-Version": "123",
//         Authorization: "Bearer " + obj,
//       },
//     })
//     .then((res) => {
//       return res.data;
//     });
// };
export const AddMedicationcategory = (obj, fdata) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/medicationCategories";
  return axios

    .post(url, fdata, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const submitClaimTag = (obj, tagPayload) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/assign-tags";
  return axios

    .post(url, tagPayload, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const deletecategory = (id, obj) => {
  return axios
    .delete(
      process.env.REACT_APP_NOT_SECRET_CODE + "/medicationCategories/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getupdatecategory = (id, obj) => {
  // console.log(id);
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + "/medicationCategories/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const updateMedicationcategory = (
  category_name,
  wt_commision,
  id,
  is_featured,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/medicationCategories/";
  return axios
    .put(
      url + id,
      {
        category_name: category_name,
        wt_commision: wt_commision,
        is_featured: is_featured,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const GetPackages = (obj, page_no) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/packages?page=" + page_no, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const AddPackage = (
  package_name,
  price,
  package_code,
  tat,
  is_featured,
  obj,
) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/packages";
  return axios
    .post(
      url,
      {
        package_name: package_name,
        price: price,
        package_code: package_code,
        tat: tat,
        is_featured: is_featured,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const DeletePackage = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/packages/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetPackage = (id, obj) => {
  // console.log(id);
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/packages/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const UpdatePackage = (
  package_name,
  price,
  package_code,
  tat,
  id,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/packages/";
  return axios
    .put(
      url + id,
      {
        package_name: package_name,
        price: price,
        package_code: package_code,
        tat: tat,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const GetReports = (obj, page_no) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/reports?page=" + page_no, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const GetDepartment = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/departments", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const AddReport = (
  title,
  package_id,
  test_code,
  unit_price,
  price,
  description,
  is_featured,
  department_id,
  parent_test,
  short_name,
  display_name,
  method_name,
  specimen_name,
  container_name,
  min_process_time,
  emergency_process_time,
  reporting_days,
  tat,
  tags,
  district,
  obj,
  reportType,
  logoData,
) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/reports";
  return axios
    .post(
      url,
      {
        title: title,
        test_code: test_code,
        description: description,
        package_id: package_id,
        unit_price: unit_price,
        price: price,
        is_featured: is_featured,
        department_id: department_id,
        parent_test: parent_test,
        short_name: short_name,
        display_name: display_name,
        method_name: method_name,
        specimen_name: specimen_name,
        container_name: container_name,
        min_process_time: min_process_time,
        emergency_process_time: emergency_process_time,
        reporting_days: reporting_days,
        tat: tat,
        tags: tags,
        district: district,
        report_type: reportType,
        icon_url: logoData,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const DeleteReport = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/reports/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetReport = (id, obj) => {
  // console.log(id);
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/reports/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const UpdateReport = (
  title,
  package_id,
  test_code,
  unit_price,
  price,
  description,
  is_featured,
  department_id,
  parent_test,
  short_name,
  display_name,
  method_name,
  specimen_name,
  container_name,
  min_process_time,
  emergency_process_time,
  reporting_days,
  id,
  tat,
  tags,
  district,
  obj,
  reportType,
  logoData,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/reports/";
  return axios
    .put(
      url + id,
      {
        title: title,
        test_code: test_code,
        description: description,
        package_id: package_id,
        unit_price: unit_price,
        price: price,
        is_featured: is_featured,
        department_id: department_id,
        parent_test: parent_test,
        short_name: short_name,
        display_name: display_name,
        method_name: method_name,
        specimen_name: specimen_name,
        container_name: container_name,
        min_process_time: min_process_time,
        emergency_process_time: emergency_process_time,
        reporting_days: reporting_days,
        tat: tat,
        tags: tags,
        district: district,
        report_type: reportType,
        icon_url: logoData,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const Addhealthtopic = (healthtopicname, country, show_in_app, obj) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/healthtopic";
  return axios
    .post(
      url,
      {
        healthtopicname: healthtopicname,
        show_in_app: show_in_app,
        country: country,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const Addhealthcondition = (
  healthconditionname,
  country,
  show_in_app,
  obj,
) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/healthcondition";
  return axios
    .post(
      url,
      {
        healthconditionname: healthconditionname,
        show_in_app: show_in_app,
        country: country,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const deletehealthcondition = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/healthcondition/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getupdatehealthcondition = (id, obj) => {
  // console.log(id);
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/healthcondition/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const updatehealthcondition = (
  healthconditionname,
  country,
  show_in_app,
  id,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/healthcondition/";
  return axios
    .put(
      url + id,
      {
        healthconditionname: healthconditionname,
        show_in_app: show_in_app,
        country: country,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const searchHealthcondition = (healthconditionname, page, obj) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/healthcondition?healthconditionname=" +
      healthconditionname;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/healthcondition?healthconditionname=" +
      healthconditionname +
      "&page=" +
      page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const deletehealthtopic = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/healthtopic/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};
export const gethealthtopicbyid = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/healthtopic/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const updatehealthtopic = (
  healthtopicname,
  show_in_app,
  country,
  id,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/healthtopic/";
  return axios
    .put(
      url + id,
      {
        healthtopicname: healthtopicname,
        show_in_app: show_in_app,
        country: country,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const searchHealthTopic = (healthtopicname, obj) => {
  let url = "";
  // if(page== "")
  // {
  //     url =process.env.REACT_APP_NOT_SECRET_CODE+'/healthtopic?healthtopicname='+healthtopicname
  // }
  // else{
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/healthtopic?healthtopicname=" +
    healthtopicname;
  // }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const SearchPackage = (
  package_code,
  package_name,
  price,
  page,
  tat,
  is_featured,
  obj,
) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/packages?package_code=" +
      package_code +
      "&package_name=" +
      package_name +
      "&price=" +
      price +
      "&tat=" +
      tat +
      "is_featured=" +
      is_featured;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/packages?package_code=" +
      package_code +
      "&package_name=" +
      package_name +
      "&price=" +
      price +
      "&page=" +
      page +
      "&tat=" +
      tat +
      "is_featured=" +
      is_featured;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      console.log(res.data);
      return res.data;
    });
};
export const getpagewiseHealthcondition = (page, country_id, obj) => {
  let url = "";

  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/healthcondition?country_id=" +
    country_id +
    "&page=" +
    page;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getallrider = (district, role, obj) => {
  let url = "";

  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/riders/" +
    role +
    "?district=" +
    district;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const getallriderAkira = (district, role, obj) => {
  let url = "";

  url = process.env.REACT_APP_AKIRA_API + "user/riders";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const getAllLabPartners = (obj) => {
  let url = "";

  url = process.env.REACT_APP_NOT_SECRET_CODE + "/labpartners";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getallCurrier = (role, obj) => {
  let url = "";

  url = process.env.REACT_APP_NOT_SECRET_CODE + "/riders/" + role;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const getMedication = (obj, pgno, records_per_page) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medications?records_per_page=" +
        records_per_page +
        "&page=" +
        pgno,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getcitywiseMedication = (obj, city, pg_no) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medications?city=" +
        city +
        "&page=" +
        pg_no,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const GetRiderlocation = (rider_id, page, from_date, to_date, obj) => {
  let url = "";
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/rider/locations?rider_id=" +
    rider_id +
    "&page=" +
    page +
    "&from_date=" +
    from_date +
    "&to_date=" +
    to_date;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const GetRiderlocationPost = (
  rider_id,
  page,
  from_date,
  to_date,
  obj,
) => {
  let url = "";
  url = process.env.REACT_APP_NOT_SECRET_CODE + "/rider/locations?page=" + page;
  return axios
    .post(
      url,
      {
        rider_id: rider_id,
        from_date: from_date,
        to_date: to_date,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const GetAkiraRiderlocationPost = (
  rider_id,
  page,
  from_date,
  to_date,
  obj,
) => {
  let url = "";
  url =
    process.env.REACT_APP_AKIRA_API +
    "rider-location/search?page=" +
    page +
    "&userId=" +
    rider_id +
    "&fromDate=" +
    from_date +
    "&toDate=" +
    to_date;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const GetRiderDistance = (rider_id, page, date, obj) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/rider/locationdata?page=" +
    page +
    "&rider_id=" +
    rider_id +
    "&from_date=" +
    date;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const GetRiderDistanceAkira = (rider_id, page, date, obj) => {
  console.log("hello");
  let url =
    process.env.REACT_APP_AKIRA_API +
    "rider-location/" +
    rider_id +
    // +
    // "&rider_id=" +
    // rider_id +
    "?date=" +
    date;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const GetLabRiderlocation = (rider_id, page, obj) => {
  let url = "";
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/rider/laborder/locations/all?rider_id=" +
    rider_id +
    "&page=" +
    page;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getMedicationwt_commsearch = (commi, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medicationCategories?wt_commision=" +
        commi,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const getMedicationcategorysearch = (char, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medicationCategories?category_name=" +
        char,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getMedicationbothsearch = (char, commi, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medicationCategories?category_name=" +
        char +
        " &&wt_commision=" +
        commi,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

// export const AddMedicationPriscription = (file,obj )=> {
//     // console.log(obj,medicationcategoryname,wt_commision);
//     const url = process.env.REACT_APP_NOT_SECRET_CODE+"/orders/prescription";
//     return axios
//      .post( url ,

//      {
//          headers : {'Content-Type' :'application/json ',
//                 'X-Request-ID': '124',
//                 'X-Country-Code': 'BD',
//                 'X-Client-Name':'WEBSITE',
//                 'X-Client-Version': '123',
//          'Authorization' : "Bearer "+obj
//      },
//      data  : file
//      })
//      .then(res =>{
//          return res
//         //  console.log(res);
//      })
//      .then (error =>
//         {
//             return error;
//         })
// }
export const checkMedication = (title, id, obj) => {
  console.log("id", id);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/medications/exist";
  return axios
    .post(
      url,
      {
        title: title,
        id: id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const AddMedication = (
  title,
  category_id,
  item_code,
  //add_commision,
  unit_price,
  city,
  description,
  is_featured,
  is_flash_medicine,
  barcode,
  quantity,
  row,
  column,
  discounted_price,
  supplier,
  primaryimage,
  packageimages,
  tags,
  sort_order,
  generic_name,
  packSize,
  is_available,
  selling_price,
  deliver_within,
  quantity_type,
  quantity_per_box,
  ismadicineout,
  supplier_name,
  country_code,
  mobile_no,
  supplier_email,
  tag,
  dosageMedi,
  dosage,
  product_categories,
  route,
  /*package_d,*/ obj,
) => {
  // console.log(obj,medicationcategoryname,wt_commision);

  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/medications";
  return axios
    .post(
      url,
      {
        title: title,
        category_id: category_id,
        price: selling_price,
        item_code: item_code,
        //add_commision: add_commision,
        unit_price: unit_price,
        country: city,
        description: description,
        is_featured: is_featured,
        barcode: barcode,
        is_flash_medicine: is_flash_medicine,
        quantity: quantity,
        xcoord: row,
        ycoord: column,
        supplier_id: supplier,
        discounted_price: discounted_price,
        primary_image: primaryimage,
        medication_images: packageimages,
        tags: tags,
        sort_order: sort_order,
        generic_name: generic_name,
        pack_size: packSize,
        deliver_within: deliver_within,
        quantity_type: quantity_type,
        quantity_per_box: quantity_per_box,
        is_available: is_available,
        is_out_of_stock: ismadicineout,
        supplier_name: supplier_name,
        country_code: country_code,
        mobile_no: mobile_no,
        supplier_email: supplier_email,
        tag: tag,
        dosage_unit: dosage,
        dosage: dosageMedi,
        product_categories: product_categories,
        route: route,
        //package_id : package_d
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const is_featured_status_change = (is_featured, id, obj) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medications/update/featured_status/" +
        id,
      { is_featured: is_featured },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const Updatereview = (id, review, obj) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/orders/adminreview/" + id,
      { review: review },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const Updatelaborderreview = (id, review, obj) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/adminreview/" + id,
      { review: review },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const is_package_featured_status_change = (is_featured, id, obj) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/reports/update/featured_status/" +
        id,
      { is_featured: is_featured },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const Edit_Commision = (commision, obj) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/medications/update/commision",
      { commision: commision },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const Get_Settings = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/settings", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const Get_Settings_byid = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/settings/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const Edit_setting = (setting_label, setting_value, id, obj) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/settings/" + id,
      {
        setting_label: setting_label,
        setting_value: setting_value,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteMedication = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/medications/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getOrderById = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/orders/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getSubscriptionOrderById = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/subscription_order/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getremaincreditforleaduser = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/leadsbalance/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const GetUsertransactionlist = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/usertrasaction_list/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const getLabOrderById = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const updateMedication_old_data = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/medications/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const updateMedication = (
  title,
  category_id,
  item_code,
  //add_commision,
  unit_price,
  city,
  description,
  is_featured,
  id,
  is_flash_medicine,
  barcode,
  quantity,
  row,
  column,
  discounted_price,
  supplier,
  primaryimage,
  packageimages,
  tags,
  sort_order,
  generic_name,
  packSize,
  is_available,
  selling_price,
  deliver_within,
  quantity_type,
  quantity_per_box,
  ismadicineout,
  tag,
  dosageMedi,
  dosage,
  product_categories,
  route,
  obj,
) => {
  //   console.log(title,category_id,item_code,add_commision,unit_price,city,description,is_featured,id ,is_flash_medicine,barcode,quantity,discounted_price,supplier,primaryimage,packageimages,tags,obj)
  // return false;
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/medications/";

  return axios
    .put(
      url + id,
      {
        title: title,
        category_id: category_id,
        price: selling_price,
        item_code: item_code,
        //add_commision: add_commision,
        unit_price: unit_price,
        country: city,
        description: description,
        is_featured: is_featured,
        barcode: barcode,
        is_flash_medicine: is_flash_medicine,
        quantity: quantity,
        xcoord: row,
        ycoord: column,
        supplier_id: supplier,
        discounted_price: discounted_price,
        primary_image: primaryimage,
        medication_images: packageimages,
        tags: tags,
        sort_order: sort_order,
        generic_name: generic_name,
        pack_size: packSize,
        deliver_within: deliver_within,
        quantity_type: quantity_type,
        quantity_per_box: quantity_per_box,
        is_available: is_available,
        is_out_of_stock: ismadicineout,
        tag: tag,
        dosage_unit: dosage,
        dosage: dosageMedi,
        product_categories: product_categories,
        route: route,
        //package_id: package_d
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const GetSubscription = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const AddSubscription = (
  title,
  description,
  category,
  price,
  subscription_period,
  remind_before,
  deliver_before,
  status,
  discount,
  eligibility,
  package_images,
  package_items,
  primary_image,
  quantity,
  Charge_type,
  Charge_value,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions";
  return axios
    .post(
      url,
      {
        title: title,
        description: description,
        category: category,
        price: price,
        subscription_period: subscription_period,
        remind_before: remind_before,
        deliver_before: deliver_before,
        status: status,
        discount: discount,
        eligibility: eligibility,
        package_images: package_images,
        package_items: package_items,
        primary_image: primary_image,
        quantity: quantity,
        charge_type: Charge_type,
        charge_value: Charge_value,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const AddSubscriptionPackage = (
  title,
  description,
  brand,
  size,
  medicine,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/package/item";
  return axios
    .post(
      url,
      {
        title: title,
        description: description,
        brand: brand,
        size: size,
        medication_id: medicine,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const getInventoryById = (id, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + "/medication/inventory/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const AddInvetory = (
  medication,
  quantity,
  expirydate,
  unit_price,
  batch_no,
  note,
  receivable_date,
  is_goods_received,
  quantity_type,
  quantity_per_box,
  obj,
  batches,
  store_id,
  xcoord,
  ycoord,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/medication/inventory";
  return axios
    .post(
      url,
      {
        expiry_date: expirydate,
        quantity: quantity,
        medication_id: medication,
        unit_price: unit_price,
        batch_no: batch_no,
        note: note,
        receivable_date: receivable_date,
        is_goods_received: is_goods_received,
        quantity_type: quantity_type,
        quantity_per_box: quantity_per_box,
        batches: batches,
        store_id: store_id,
        xcoord: xcoord,
        ycoord: ycoord,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const UpdateInvetory = (
  medication,
  quantity,
  expirydate,
  unit_price,
  note,
  receivable_date,
  is_goods_received,
  quantity_type,
  quantity_per_box,
  obj,
  id,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/medication/inventory/" + id;
  return axios
    .put(
      url,
      {
        medication_id: medication,
        expiry_date: expirydate,
        quantity: quantity,
        unit_price: unit_price,
        note: note,
        receivable_date: receivable_date,
        is_goods_received: is_goods_received,
        quantity_type: quantity_type,
        quantity_per_box: quantity_per_box,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const EditSubscriptionPackage = (
  title,
  description,
  brand,
  size,
  medicine,
  id,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/package/item/" + id;
  return axios
    .put(
      url,
      {
        title: title,
        description: description,
        brand: brand,
        size: size,
        medication_id: medicine,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const GetInventoryList = (obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/medication/inventory";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const searchInvetory = (medication_title, expiry_date, page, obj) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/medication/inventory?medication_title=" +
      medication_title +
      "&expiry_date=" +
      expiry_date;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/medication/inventory?medication_title=" +
      medication_title +
      "&expiry_date=" +
      expiry_date +
      "&page=" +
      page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const GetSubscriptionPackageByID = (id, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/package/item/" + id;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const GetAllSuppliers = (obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/medications/suppliers/list";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const GetAllSubscriptionPackageItem = (page, obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/package/item?page=" + page;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const GetSubscriptionPackageList = (obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/package/item";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const DeleteSubscriptionPackage = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/package/item/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const AddAdminCredit = (
  user_id,
  points,
  note_title,
  credit_type,
  note_description,
  is_flash_voucher,
  org_id,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/addcredit";
  console.log({
    user_id: user_id,
    points: points,
    credit_type: credit_type,
    note_title: note_title,
    note_description: note_description,
    is_flash_voucher: is_flash_voucher,
    org_id: org_id,
  });
  return axios
    .post(
      url,
      {
        user_id: user_id,
        points: points,
        credit_type: credit_type,
        note_title: note_title,
        note_description: note_description,
        is_flash_voucher: is_flash_voucher,
        org_id: org_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const DeleteSubscription = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateSubscription_old_data = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const updateSubscription = (
  title,
  description,
  category,
  price,
  subscription_period,
  remind_before,
  deliver_before,
  status,
  discount,
  eligibility,
  package_images,
  package_items,
  primary_image,
  id,
  quantity,
  Charge_type,
  Charge_value,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions/";
  return axios
    .put(
      url + id,
      {
        title: title,
        description: description,
        category: category,
        price: price,
        subscription_period: subscription_period,
        remind_before: remind_before,
        deliver_before: deliver_before,
        status: status,
        discount: discount,
        eligibility: eligibility,
        package_images: package_images,
        package_items: package_items,
        primary_image: primary_image,
        quantity: quantity,
        charge_type: Charge_type,
        charge_value: Charge_value,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const getallLead = (obj) => {
  // console.log(obj)
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/leads", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const getLead = (id, obj) => {
  // console.log(obj)
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/leads?status=" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res.data);
      return res.data;
    });
};

export const updateOrderStatus = (
  orders,
  cancel_reason,
  cancel_message,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/update/status";
  return axios
    .put(
      url,
      {
        orders: orders,
        cancel_reason: cancel_reason,
        cancel_message: cancel_message,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const updatesubscriptionOrderStatus = (orders, obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/subscription_order_change_status";
  return axios
    .put(
      url,
      {
        orders: orders,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const updateOrdersRider = (
  order_id,
  rider_id,
  order_status,
  is_courrier,
  tracking_id,
  tracking_url,
  tracking_note,
  store,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/update/rider";
  return axios
    .put(
      url,
      {
        order_id: order_id,
        rider_id: rider_id,
        order_status: order_status,
        is_courier_partner: is_courrier,
        tracking_id: tracking_id,
        tracking_url: tracking_url,
        tracking_note: tracking_note,
        store_id: store,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const updateLabOrdersRider = (order_id, rider_id, order_status, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/update/rider";
  return axios
    .put(
      url,
      {
        order_id: order_id,
        rider_id: rider_id,
        order_status: order_status,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const updateSubscriptionDeliveryStatus = (
  orders,
  delivery_date,
  obj,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/subscription_order_update_delivery_status";
  return axios
    .put(
      url,
      {
        orders: orders,
        delivery_date: delivery_date,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const sendNotificationSMS = (order_id, notification_type, obj) => {
  console.log(order_id, "order id");
  console.log(obj, "obj");
  console.log({ notification_type: notification_type, order_id: order_id });
  //  return;
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/orders/notify/" + order_id,
      { notification_type: notification_type },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const ChargeOrder = (order_id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/orders/charge/" + order_id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const downloadLeadSample = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/leads/export/excel", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const downloadLabOrderSample = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/export/excel", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const downloadMedicineOrderSample = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/orders/export/excel", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const ChargeSubscriptionOrder = (order_id, obj) => {
  console.log(order_id, "order id");
  console.log(obj, "obj");
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/subscription_order_details/chargeCustomer/" +
        order_id,
      { order_id: order_id },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const CancelSubscriptionOrder = (order_id, obj) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/subscription_order/cancel/" +
        order_id,
      { order_id: order_id },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const updateSubscriptionRider = (
  orders,
  rider_id,
  delivery_date,
  obj,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/subscription_order_update_rider";
  return axios
    .put(
      url,
      {
        orders: orders,
        delivery_date: delivery_date,
        rider_id: rider_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const updateLabOrderStatus = (orders, cancel_reason, obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/update/status";
  return axios
    .put(
      url,
      {
        orders: orders,
        cancel_reason: cancel_reason,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const updateMedicationStatus = (data, obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medications/outOfStockChanges/status";
  return axios
    .post(
      url,
      { data: data },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const AddLead = (
  name,
  email,
  mobile_no,
  phone,
  leads_status,
  addresses,
  comments,
  source,
  organization_id,
  channel,
  gender,
  date_of_birth,
  passport_no,
  body_tem,
  occupation,
  moh_area,
  patient_name,
  patient_contact_no,
  patient_email_id,
  emergency_contact_name,
  emergency_contact_no,
  symptoms,
  epidemiological_evidence,
  is_b2b,
  obj,
  country_code,
  store_id,
) => {
  // console.log(name,email,mobile_no,phone,leads_status,address_line1,address_line2,state,city,country_id,postal_code,comments,source);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/leads";
  return axios
    .post(
      url,
      {
        name: name,
        email: email,
        mobile_no: mobile_no,
        phone: phone,
        leads_status: leads_status,
        gender: gender,
        date_of_birth: date_of_birth,
        passport_no: passport_no,
        body_tem: body_tem,
        occupation: occupation,
        moh_area: moh_area,
        patient_name: patient_name,
        patient_contact_no: patient_contact_no,
        patient_email_id: patient_email_id,
        emergency_contact_name: emergency_contact_name,
        emergency_contact_no: emergency_contact_no,
        symptoms: symptoms,
        epidemiological_evidence: epidemiological_evidence,
        // lead_owner_id : lead_owner_id,
        source: source,
        // address_line1: address_line1,
        // address_line2 : address_line2,
        // state : state,
        // city : city,
        // country_id : country_id,
        // postal_code : postal_code,
        addresses: addresses,
        comments: comments,
        organization_id: organization_id,
        channel: channel,
        is_b2b: is_b2b,
        country_code: country_code,
        store_id: store_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const DeleteLead = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/leads/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const get_lead_old_data = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/leads/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const GetUserSubscriptionOrderData = (id, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/subscription_order/user?lead_id=" +
        id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getmedicationdatabyid = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/medications/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const updateLead = (
  name,
  email,
  mobile_no,
  phone,
  leads_status,
  addresses,
  comments,
  source,
  organization_id,
  channel,
  gender,
  date_of_birth,
  passport_no,
  body_tem,
  occupation,
  moh_area,
  patient_name,
  patient_contact_no,
  patient_email_id,
  emergency_contact_name,
  emergency_contact_no,
  symptoms,
  epidemiological_evidence,
  id,
  deleted_address_id,
  is_b2b,
  obj,
  country_code,
  lead_packages,
  store_id,
) => {
  const packages = [];
  lead_packages.map((item) => {
    packages.push(item.value);
  });
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/leads/";
  return axios
    .put(
      url + id,
      {
        name: name,
        email: email,
        mobile_no: mobile_no,
        phone: phone,
        leads_status: leads_status,
        gender: gender,
        date_of_birth: date_of_birth,
        passport_no: passport_no,
        body_tem: body_tem,
        occupation: occupation,
        moh_area: moh_area,
        patient_name: patient_name,
        patient_contact_no: patient_contact_no,
        patient_email_id: patient_email_id,
        emergency_contact_name: emergency_contact_name,
        emergency_contact_no: emergency_contact_no,
        symptoms: symptoms,
        epidemiological_evidence: epidemiological_evidence,
        // lead_owner_id : lead_owner_id,
        addresses: addresses,
        comments: comments,
        source: source,
        organization_id: organization_id,
        channel: channel,
        deleted_address_id: deleted_address_id,
        is_b2b: is_b2b,
        country_code: country_code,
        package_ids: packages,
        store_id: store_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const GetSubscriber = (obj, pg_no, records_per_page) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/leads?status=3&records_per_page=" +
        records_per_page +
        "&page=" +
        pg_no,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      console.log(res.data);
      return res.data;
    });
};

export const registration = (
  name,
  mobile_no,
  email,
  password,
  c_password,
  role,
  speciality_id,
  profile_picture_url,
  priscription_data,
  addressline1,
  addressline2,
  city,
  postalcode,
  state,
  country,
  is_sales_rep,
  gender,
  qualification,
  registration_id,
  signature_file,
  consultation_fee,
  consultation_rate,
  lab_rate,
  medication_rate,
  doc_languages,
  quality,
  is_show_in_app,
  doctor_prefix,
  doctor_preference,
  company_name,
  district,
  countryCode,
  chargeType,
  storeId,
  is_Home_Care_Enabled,
  department,
  sort,
  leadTime,
  leadTimeBuffer,
) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/register",
      {
        name: name,
        email: email,
        mobile: mobile_no,
        password: password,
        c_password: c_password,
        role: role,
        speciality_id: speciality_id,
        profile_picture_url: profile_picture_url,
        proof_url: priscription_data,
        address_type: "home",
        address_line1: addressline1,
        address_line2: addressline2,
        city_id: city,
        state: state,
        country_id: country,
        postal_code: postalcode,
        is_sales_rep: is_sales_rep,
        gender: gender,
        qualification: qualification,
        registration_id: registration_id,
        signature_url: signature_file,
        consultation_fee: consultation_fee,
        consultation_rate: consultation_rate,
        lab_order_rate: lab_rate,
        medication_rate: medication_rate,
        language: doc_languages,
        quality: quality,
        is_show_in_app: is_show_in_app,
        doctor_prefix: doctor_prefix,
        doctor_preference: doctor_preference,
        company_tag: company_name,
        district: district,
        country_code: countryCode,
        charge_type: chargeType,
        store_id: storeId,
        is_homecare_enabled: is_Home_Care_Enabled,
        department: department,
        sort: sort,
        lead_time_days: leadTime,
        lead_time_days_buffer: leadTimeBuffer,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateuser = (
  name,
  mobile_no,
  email,
  role,
  doc_speciality,
  id,
  obj,
  profile_picture_url,
  priscription_data,
  addressline1,
  addressline2,
  city,
  postalcode,
  state,
  country,
  is_sales_rep,
  gender,
  qualification,
  registration_id,
  signature_file,
  consultation_fee,
  consultation_rate,
  lab_rate,
  medication_rate,
  doc_languages,
  quality,
  is_show_in_app,
  doctor_prefix,
  doctor_preference,
  companyName,
  district,
  country_code,
  chargeType,
  storeId,
  is_Home_Care_Enabled,
  department,
  sort,
  leadTime,
  leadTimeBuffer,
) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/users/" + id,
      {
        name: name,
        email: email,
        mobile: mobile_no,
        role: role,
        speciality_id: doc_speciality,
        profile_picture_url: profile_picture_url,
        proof_url: priscription_data,
        address_type: "home",
        address_line1: addressline1,
        address_line2: addressline2,
        city_id: city,
        state: state,
        country_id: country,
        postal_code: postalcode,
        is_sales_rep: is_sales_rep,
        gender: gender,
        qualification: qualification,
        registration_id: registration_id,
        signature_url: signature_file,
        consultation_fee: consultation_fee,
        consultation_rate: consultation_rate,
        lab_order_rate: lab_rate,
        medication_rate: medication_rate,
        language: doc_languages,
        quality: quality,
        is_show_in_app: is_show_in_app,
        doctor_prefix: doctor_prefix,
        doctor_preference: doctor_preference,
        company_tag: companyName,
        country_code: country_code,
        district: district,
        charge_type: chargeType,
        store_id: storeId,
        is_homecare_enabled: is_Home_Care_Enabled,
        department: department,
        sort: sort,
        lead_time_days: leadTime,
        lead_time_days_buffer: leadTimeBuffer,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const deleteUser = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/users/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const resetpassword = (email, password, confirm_password, token) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/resetpassword",
      {
        email: email,
        password: password,
        confirm_password: confirm_password,
        token: token,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "12",
        },
      },
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const forgotpassword = (email) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/forgotpassword",
      {
        email: email,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "12",
        },
      },
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const loginuser = (email, password) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/login",
      {
        email: email,
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "12",
        },
      },
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const Logout = () => {
  return axios
    .post(process.env.REACT_APP_NOT_SECRET_CODE + "/logout", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "12",
        // 'Authorization' : "Bearer "+obj
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const UpdateDeliveryStatus = (delivery_id, order_id, obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/subscription_order_update_delivery_status_by_delivery";
  return axios
    .put(
      url,
      {
        order_id: order_id,
        delivery_id: delivery_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const AddOrder = (
  lead_id,
  source,
  opharma_reference,
  order_date,
  prescription_file,
  prescription_file_url,
  delivery_type,
  delivery_charge,
  comments,
  address_id,
  address_line1,
  address_line2,
  city,
  postal_code,
  country_id,
  channel,
  medications,
  obj,
  basketvalue,
  totalcost,
  lastsubscriptionorder,
  shipping_email,
  shipping_name,
  shipping_mobile,
  shipping_phone,
  status,
  prescription_url,
  margin_type,
  margin,
  organization_discount,
  tags,
  paymentoption,
  payment_due_date,
  order_note,
  mypharma_reference,
  rider_id,
  not_get_medicine,
  is_currier_partner,
  tracking_id,
  tracking_note,
  tracking_url,
  sales_user_id,
  delivery_from_date,
  delivery_to_date,
  isDeliveryCharge,
  order_sub_type,
  po_number,
  po_document_url,
  grn_document_url,
  flash_reference,
  isPartialOrder,
  isAbusableOrder,
  item_description,
  is_claimable,
  latitude,
  longitude,
  addressType,
  customAddress,
  store,
  billing_address_id,
  filteredBatches,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders";
  return axios
    .post(
      url,
      {
        lead_id: lead_id,
        source: source,
        opharma_reference: flash_reference,
        order_date: order_date,
        prescription_file: prescription_url,
        prescription_file_url: prescription_url,
        delivery_type: delivery_type,
        delivery_charge: delivery_charge,
        comments: comments,
        address_id: address_id,
        address_line1: address_line2,
        address_line2: address_line1,
        city: city,
        country_id: country_id,
        postal_code: postal_code,
        channel: channel,
        not_get_medicine: not_get_medicine,
        // created_by : created_by,
        medications: medications,
        // shipping_email : shipping_email,
        // shipping_mobile : shipping_mobile,
        // shipping_name : shipping_name,
        // shipping_phone : shipping_phone,
        order_status: status,
        margin_type: margin_type,
        margin: margin,
        organization_discount: organization_discount,
        tags: tags,
        paymentoption: paymentoption,
        payment_due_date: payment_due_date,
        order_note: order_note,
        mypharma_reference: mypharma_reference,
        rider_id: rider_id,
        is_courier_partner: is_currier_partner,
        tracking_id: tracking_id,
        tracking_note: tracking_note,
        tracking_url: tracking_url,
        sales_user_id: sales_user_id,
        delivery_from_date: delivery_from_date,
        delivery_to_date: delivery_to_date,
        package_delivery_discount: isDeliveryCharge,
        order_sub_type: order_sub_type,
        po_number: po_number,
        grn_file: grn_document_url,
        po_file: po_document_url,
        partial_sent: isPartialOrder,
        is_abusable: isAbusableOrder,
        item_description: item_description,
        // basket_value : basket_value,
        // total_cost : total_cost,
        // last_subscription_order : last_subscription_order,
        // orderItems : orderItems,
        is_claimable: is_claimable,
        latitude: latitude,
        longitude: longitude,
        address_type: addressType,
        customaddress: customAddress,
        store_id: store,
        billing_address_id: billing_address_id,
        batches: filteredBatches,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const AddSubscriptionOrder = (
  lead_id,
  subscription_date,
  delivery_type,
  delivery_charge,
  address_id,
  address_line1,
  address_line2,
  city,
  postal_code,
  country_id,
  channel,
  packages,
  obj,
  order_status,
  paymentoption,
  delivery_date,
  order_note,
  rider_id,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscription_order";
  return axios
    .post(
      url,
      {
        lead_id: lead_id,
        subscription_date: subscription_date,
        preferred_delivery_date: delivery_date,
        delivery_type: delivery_type,
        delivery_charge: delivery_charge,
        address_id: address_id,
        address_line1: address_line1,
        address_line2: address_line2,
        city: city,
        country_id: country_id,
        postal_code: postal_code,
        channel: channel,
        packages: packages,
        order_status: order_status,
        paymentoption: paymentoption,
        order_note: order_note,
        rider_id: rider_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const AddLabOrder = (
  lead_id,
  source,
  opharma_reference,
  order_date,
  prescription_file,
  prescription_file_url,
  delivery_type,
  delivery_charge,
  comments,
  address_id,
  address_line1,
  address_line2,
  city,
  postal_code,
  country_id,
  channel,
  reports,
  obj,
  basketvalue,
  totalcost,
  lastsubscriptionorder,
  shipping_email,
  shipping_name,
  shipping_mobile,
  shipping_phone,
  status,
  prescription_url,
  margin_type,
  margin,
  organization_discount,
  tags,
  paymentoption,
  payment_due_date,
  order_note,
  mypharma_reference,
  rider_id,
  testing_purpose,
  institute,
  collector_name,
  patient_condition,
  sample_type,
  place_of_sample_collection,
  mode_of_transportation,
  delivery_date,
  delivery_time,
  show_instruction1,
  show_instruction2,
  generic_report_file,
  sales_user_id,
  order_sub_type,
  is_claimable,
  labPartnerName,
  latitude,
  longitude,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/laborders";
  let request_array = [];
  request_array = {
    lead_id: lead_id,
    source: source,
    opharma_reference: opharma_reference,
    order_date: order_date,
    prescription_file: prescription_url,
    prescription_file_url: prescription_url,
    delivery_type: delivery_type,
    delivery_charge: delivery_charge,
    comments: comments,
    address_id: address_id,
    address_line1: address_line1,
    address_line2: address_line2,
    city: city,
    country_id: country_id,
    postal_code: postal_code,
    channel: channel,
    institute: institute,
    collector_name: collector_name,
    // created_by : created_by,
    show_instruction1: show_instruction1,
    show_instruction2: show_instruction2,
    reports: reports,
    delivery_date: delivery_date,
    delivery_time: delivery_time,
    // shipping_email : shipping_email,
    // shipping_mobile : shipping_mobile,
    // shipping_name : shipping_name,
    // shipping_phone : shipping_phone,
    order_status: status,
    margin_type: margin_type,
    margin: margin,
    organization_discount: organization_discount,
    tags: tags,
    paymentoption: paymentoption,
    payment_due_date: payment_due_date,
    order_note: order_note,
    mypharma_reference: mypharma_reference,
    rider_id: rider_id,
    generic_report_file: generic_report_file,
    sales_user_id: sales_user_id,
    order_sub_type: order_sub_type,
    is_claimable: is_claimable,
    lab_partner_name: labPartnerName,
    latitude: latitude,
    longitude: longitude,
  };
  if (testing_purpose !== "" || testing_purpose.length !== 0) {
    request_array["testing_purpose"] = testing_purpose;
  }
  if (patient_condition !== "" || patient_condition.length !== 0) {
    request_array["patient_condition"] = patient_condition;
  }
  if (sample_type !== "" || sample_type.length !== 0) {
    request_array["sample_type"] = sample_type;
  }
  if (
    place_of_sample_collection !== "" ||
    place_of_sample_collection.length !== 0
  ) {
    request_array["place_of_sample_collection"] = place_of_sample_collection;
  }
  if (mode_of_transportation !== "" || mode_of_transportation.length !== 0) {
    request_array["mode_of_transportation"] = mode_of_transportation;
  }

  return axios
    .post(url, request_array, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const updateQuote = (
  lead_id,
  source,
  opharma_reference,
  order_date,
  prescription_file,
  prescription_file_url,
  delivery_type,
  delivery_charge,
  comments,
  address_id,
  address_line1,
  address_line2,
  city,
  postal_code,
  country_id,
  channel,
  isAbusableOrder,
  medications,
  obj,
  basketvalue,
  totalcost,
  lastsubscriptionorder,
  shipping_email,
  shipping_name,
  shipping_mobile,
  shipping_phone,
  status,
  priscription_data,
  margin_type,
  margin,
  organization_discount,
  tags,
  paymentoption,
  prescription_text,
  not_get_medicine,
  id,
  deleted_ids,
  rider_id,
  is_currier_partner,
  tracking_id,
  tracking_note,
  tracking_url,
  delivery_from_date,
  delivery_to_date,
  order_sub_type,
  po_number,
  po_document_url,
  grn_document_url,
  sales_user_id,
  latitude,
  longitude,
  addressType,
  customAddress,
  filterdBatches,
  // item_description,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/orders/quote/update/" + id;
  return axios
    .put(
      url,
      {
        lead_id: lead_id,
        source: source,
        opharma_reference: opharma_reference,
        order_date: order_date,
        prescription_file: priscription_data,
        prescription_file_url: prescription_file_url,
        prescription_text: prescription_text,
        delivery_type: delivery_type,
        delivery_charge: delivery_charge,
        comments: lastsubscriptionorder,
        address_id: address_id,
        shipping_name: shipping_name,
        shipping_email: shipping_email,
        shipping_mobile: shipping_mobile,
        shipping_phone: shipping_phone,
        address_line1: address_line2,
        address_line2: address_line1,
        city: city,
        status: status,
        not_get_medicine: not_get_medicine,
        country_id: country_id,
        postal_code: postal_code,
        channel: channel,
        is_abusable: isAbusableOrder,
        paymentoption: paymentoption,
        medications: medications,
        // created_by : created_by,
        tags: tags,
        organization_discount: organization_discount,
        rider_id: rider_id,
        is_courier_partner: is_currier_partner,
        tracking_id: tracking_id,
        tracking_note: tracking_note,
        tracking_url: tracking_url,
        // basket_value : basket_value,
        // total_cost : total_cost,
        // last_subscription_order : last_subscription_order,
        // orderItems : orderItems,
        deleted_item_id: deleted_ids,
        delivery_from_date: delivery_from_date,
        delivery_to_date: delivery_to_date,
        order_sub_type: order_sub_type,
        po_number: po_number,
        po_file: po_document_url,
        grn_file: grn_document_url,
        sales_user_id: sales_user_id,
        latitude: latitude,
        longitude: longitude,
        address_type: addressType,
        customaddress: customAddress,
        batches: filterdBatches,
        // item_description: item_description,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      console.log(res, "isAbusableOrder");
      return res;
    });
};
export const SendQuoteLabOrder = (
  lead_id,
  source,
  opharma_reference,
  order_date,
  prescription_file,
  prescription_file_url,
  delivery_type,
  delivery_charge,
  comments,
  address_id,
  address_line1,
  address_line2,
  city,
  postal_code,
  country_id,
  channel,
  reports,
  obj,
  basketvalue,
  totalcost,
  lastsubscriptionorder,
  shipping_email,
  shipping_name,
  shipping_mobile,
  shipping_phone,
  status,
  prescription_url,
  margin_type,
  margin,
  organization_discount,
  tags,
  paymentoption,
  payment_due_date,
  order_note,
  mypharma_reference,
  rider_id,
  testing_purpose,
  institute,
  collector_name,
  patient_condition,
  sample_type,
  place_of_sample_collection,
  mode_of_transportation,
  delivery_date,
  delivery_time,
  show_instruction1,
  show_instruction2,
  order_sub_type,
  latitude,
  longitude,
) => {
  console.log(show_instruction1, show_instruction2);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/sendquote";
  return axios
    .post(
      url,
      {
        lead_id: lead_id,
        source: source,
        opharma_reference: opharma_reference,
        order_date: order_date,
        prescription_file: prescription_url,
        prescription_file_url: prescription_url,
        delivery_type: delivery_type,
        delivery_charge: delivery_charge,
        comments: comments,
        address_id: address_id,
        address_line1: address_line1,
        address_line2: address_line2,
        city: city,
        country_id: country_id,
        postal_code: postal_code,
        channel: channel,
        show_instruction1: show_instruction1,
        show_instruction2: show_instruction2,
        testing_purpose: testing_purpose,
        institute: institute,
        collector_name: collector_name,
        patient_condition: patient_condition,
        sample_type: sample_type,
        place_of_sample_collection: place_of_sample_collection,
        mode_of_transportation: mode_of_transportation,
        // created_by : created_by,
        reports: reports,
        delivery_date: delivery_date,
        delivery_time: delivery_time,
        // shipping_email : shipping_email,
        // shipping_mobile : shipping_mobile,
        // shipping_name : shipping_name,
        // shipping_phone : shipping_phone,
        order_status: status,
        margin_type: margin_type,
        margin: margin,
        organization_discount: organization_discount,
        tags: tags,
        paymentoption: paymentoption,
        payment_due_date: payment_due_date,
        order_note: order_note,
        mypharma_reference: mypharma_reference,
        rider_id: rider_id,
        order_sub_type: order_sub_type,
        latitude: latitude,
        longitude: longitude,

        // basket_value : basket_value,
        // total_cost : total_cost,
        // last_subscription_order : last_subscription_order,
        // orderItems : orderItems,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const SendQuote = (
  lead_id,
  source,
  opharma_reference,
  order_date,
  prescription_file,
  prescription_file_url,
  delivery_type,
  delivery_charge,
  comments,
  address_id,
  address_line1,
  address_line2,
  city,
  postal_code,
  country_id,
  channel,
  medications,
  basketvalue,
  totalcost,
  lastsubscriptionorder,
  shipping_email,
  shipping_name,
  shipping_mobile,
  shipping_phone,
  status,
  priscription_data,
  margin_type,
  margin,
  organization_discount,
  tags,
  paymentoption,
  prescription_text,
  not_get_medicine,
  rider_id,
  is_currier_partner,
  tracking_id,
  tracking_note,
  tracking_url,
  delivery_from_date,
  delivery_to_date,
  order_sub_type,
  po_number,
  po_document_url,
  grn_document_url,
  item_description,
  isAbusableOrder,
  latitude,
  longitude,
  addressType,
  customAddress,
  filterdBatches,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/quote/send";
  return axios
    .post(
      url,
      {
        lead_id: lead_id,
        source: source,
        opharma_reference: opharma_reference,
        order_date: order_date,
        prescription_file: priscription_data,
        prescription_file_url: prescription_file_url,
        prescription_text: prescription_text,
        delivery_type: delivery_type,
        delivery_charge: delivery_charge,
        comments: lastsubscriptionorder,
        address_id: address_id,
        shipping_name: shipping_name,
        shipping_email: shipping_email,
        shipping_mobile: shipping_mobile,
        shipping_phone: shipping_phone,
        address_line1: address_line1,
        address_line2: address_line2,
        city: city,
        status: status,
        country_id: country_id,
        postal_code: postal_code,
        channel: channel,
        is_abusable: isAbusableOrder,
        not_get_medicine: not_get_medicine,
        paymentoption: paymentoption,
        medications: medications,
        // created_by : created_by,
        tags: tags,
        organization_discount: organization_discount,
        rider_id: rider_id,
        is_courier_partner: is_currier_partner,
        tracking_id: tracking_id,
        tracking_note: tracking_note,
        tracking_url: tracking_url,
        delivery_from_date: delivery_from_date,
        delivery_to_date: delivery_to_date,
        order_sub_type: order_sub_type,
        po_number: po_number,
        po_file: po_document_url,
        grn_file: grn_document_url,
        item_description: item_description,
        latitude: latitude,
        longitude: longitude,
        address_type: addressType,
        customaddress: customAddress,
        batches: filterdBatches,
        // basket_value : basket_value,
        // total_cost : total_cost,
        // last_subscription_order : last_subscription_order,
        // orderItems : orderItems,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const SendB2bEmailNotification = (
  order_id,
  b2bEmail,
  validityDate,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/b2bemail/send";
  return axios
    .post(
      url,
      {
        order_id: order_id,
        b2bEmail: b2bEmail,
        validityDate: validityDate,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const EditOrder = (
  lead_id,
  source,
  opharma_reference,
  order_date,
  prescription_file,
  prescription_file_url,
  delivery_type,
  delivery_charge,
  comments,
  address_id,
  address_line1,
  address_line2,
  city,
  postal_code,
  country_id,
  channel,
  medications,
  obj,
  basketvalue,
  totalcost,
  lastsubscriptionorder,
  id,
  name,
  mobileno,
  phoneno,
  email,
  status,
  prescription_url,
  margin_type,
  margin,
  organization_discount,
  tags,
  paymentoption,
  payment_due_date,
  order_note,
  mypharma_reference,
  rider_id,
  prescription_text,
  request_quote_notification,
  not_get_medicine,
  deleted_item_id,
  is_currier_partner,
  tracking_id,
  tracking_note,
  tracking_url,
  sales_user_id,
  delivery_from_date,
  delivery_to_date,
  order_sub_type,
  po_number,
  po_document_url,
  grn_document_url,
  flash_reference,
  reFillableOrder,
  isPartialOrder,
  isAbusableOrder,
  item_description,
  is_claimable,
  latitude,
  longitude,
  addressType,
  customAddress,
  isInsureMe,
  store,
  billing_address_id,
  pr_id,
  batches,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/" + id;
  return axios
    .put(
      url,
      {
        lead_id: lead_id,
        source: source,
        opharma_reference: flash_reference,
        order_date: order_date,
        prescription_file: prescription_url,
        prescription_file_url: prescription_url,
        prescription_text: prescription_text,
        delivery_type: delivery_type,
        delivery_charge: delivery_charge,
        comments: comments,
        address_id: address_id,
        address_line1: address_line2,
        address_line2: address_line1,
        city: city,
        country_id: country_id,
        postal_code: postal_code,
        channel: channel,
        not_get_medicine: not_get_medicine,
        // created_by : created_by,
        medications: medications,
        request_quote_notification: request_quote_notification,
        shipping_name: name,
        shipping_email: email,
        shipping_mobile: mobileno,
        shipping_phone: phoneno,
        order_status: status,
        margin_type: margin_type,
        margin: margin,
        organization_discount: organization_discount,
        tags: tags,
        paymentoption: paymentoption,
        payment_due_date: payment_due_date,
        order_note: order_note,
        mypharma_reference: mypharma_reference,
        rider_id: rider_id,
        is_courier_partner: is_currier_partner,
        tracking_id: tracking_id,
        tracking_note: tracking_note,
        tracking_url: tracking_url,
        sales_user_id: sales_user_id,

        // basket_value : basket_value,
        // total_cost : total_cost,
        // last_subscription_order : last_subscription_order,
        // orderItems : orderItems,
        deleted_item_id: deleted_item_id,
        delivery_from_date: delivery_from_date,
        delivery_to_date: delivery_to_date,
        order_sub_type: order_sub_type,
        po_number: po_number,
        po_file: po_document_url,
        grn_file: grn_document_url,
        is_refillable: reFillableOrder,
        partial_sent: isPartialOrder,
        is_abusable: isAbusableOrder,
        item_description: item_description,
        is_claimable: is_claimable,
        latitude: latitude,
        longitude: longitude,
        address_type: addressType,
        customaddress: customAddress,
        is_insureme: isInsureMe,
        store_id: store,
        billing_address_id: billing_address_id,
        pr_id: pr_id,
        batches: batches,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const EditSubscriptionOrder = (
  lead_id,
  subscription_date,
  delivery_type,
  delivery_charge,
  address_id,
  address_line1,
  address_line2,
  city,
  postal_code,
  country_id,
  channel,
  packages,
  obj,
  id,
  order_status,
  paymentoption,
  delivery_date,
  order_note,
  rider_id,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/subscription_order/" + id;
  return axios
    .put(
      url,
      {
        lead_id: lead_id,
        subscription_date: subscription_date,
        preferred_delivery_date: delivery_date,
        delivery_type: delivery_type,
        delivery_charge: delivery_charge,
        address_id: address_id,
        address_line1: address_line1,
        address_line2: address_line2,
        city: city,
        country_id: country_id,
        postal_code: postal_code,
        channel: channel,
        packages: packages,
        order_status: order_status,
        paymentoption: paymentoption,
        order_note: order_note,
        rider_id: rider_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const EditLabOrder = (
  lead_id,
  opharma_reference,
  order_date,
  prescription_file,
  prescription_file_url,
  delivery_charge,
  comments,
  address_id,
  address_line1,
  address_line2,
  city,
  postal_code,
  country_id,
  channel,
  reports,
  obj,
  basketvalue,
  totalcost,
  lastsubscriptionorder,
  id,
  name,
  mobileno,
  phoneno,
  email,
  status,
  prescription_url,
  margin_type,
  margin,
  organization_discount,
  tags,
  paymentoption,
  payment_due_date,
  order_note,
  mypharma_reference,
  rider_id,
  testing_purpose,
  institute,
  collector_name,
  patient_condition,
  sample_type,
  place_of_sample_collection,
  mode_of_transportation,
  delivery_date,
  delivery_time,
  request_quote_notification,
  show_instruction1,
  show_instruction2,
  genericreport_data,
  sales_user_id,
  order_sub_type,
  lab_partner_id,
  lab_partner_name,
  source,
  is_Claimable,
  latitude,
  longitude,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/" + id;
  let request_array = [];
  request_array = {
    lead_id: lead_id,
    // source : source,
    opharma_reference: opharma_reference,
    order_date: order_date,
    prescription_file: prescription_url,
    prescription_file_url: prescription_url,
    // delivery_type : delivery_type,
    // report_file : report_file,
    delivery_charge: delivery_charge,
    comments: comments,
    address_id: address_id,
    address_line1: address_line1,
    address_line2: address_line2,
    city: city,
    country_id: country_id,
    request_quote_notification: request_quote_notification,
    postal_code: postal_code,
    channel: channel,
    institute: institute,
    collector_name: collector_name,
    delivery_date: delivery_date,
    delivery_time: delivery_time,
    show_instruction1: show_instruction1,
    show_instruction2: show_instruction2,
    // created_by : created_by,
    reports: reports,
    shipping_name: name,
    shipping_email: email,
    shipping_mobile: mobileno,
    shipping_phone: phoneno,
    order_status: status,
    margin_type: margin_type,
    margin: margin,
    organization_discount: organization_discount,
    tags: tags,
    paymentoption: paymentoption,
    payment_due_date: payment_due_date,
    order_note: order_note,
    mypharma_reference: mypharma_reference,
    rider_id: rider_id,
    generic_report_file: genericreport_data,
    sales_user_id: sales_user_id,
    order_sub_type: order_sub_type,
    lab_partner_id: lab_partner_id,
    lab_partner_name: lab_partner_name,
    source: source,
    is_claimable: is_Claimable,
    latitude: latitude,
    longitude: longitude,
  };
  console.log(testing_purpose);
  if (testing_purpose != null) {
    if (testing_purpose !== "" || testing_purpose.length !== 0) {
      request_array["testing_purpose"] = testing_purpose;
      console.log(request_array);
    }
  }
  if (patient_condition != null) {
    if (patient_condition !== "" || patient_condition.length !== 0) {
      request_array["patient_condition"] = patient_condition;
    }
  }
  if (sample_type != null) {
    if (sample_type !== "" || sample_type.length !== 0) {
      request_array["sample_type"] = sample_type;
    }
  }
  if (place_of_sample_collection != null) {
    if (
      place_of_sample_collection !== "" ||
      place_of_sample_collection.length !== 0
    ) {
      request_array["place_of_sample_collection"] = place_of_sample_collection;
    }
  }
  if (mode_of_transportation != null) {
    if (mode_of_transportation !== "" || mode_of_transportation.length !== 0) {
      request_array["mode_of_transportation"] = mode_of_transportation;
    }
  }

  return axios
    .put(url, request_array, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const EditQuoteLabOrder = (
  lead_id,
  opharma_reference,
  order_date,
  prescription_file,
  prescription_file_url,
  delivery_charge,
  comments,
  address_id,
  address_line1,
  address_line2,
  city,
  postal_code,
  country_id,
  channel,
  reports,
  obj,
  basketvalue,
  totalcost,
  lastsubscriptionorder,
  id,
  name,
  mobileno,
  phoneno,
  email,
  status,
  prescription_url,
  margin_type,
  margin,
  organization_discount,
  tags,
  paymentoption,
  payment_due_date,
  order_note,
  mypharma_reference,
  rider_id,
  testing_purpose,
  institute,
  collector_name,
  patient_condition,
  sample_type,
  place_of_sample_collection,
  mode_of_transportation,
  delivery_date,
  delivery_time,
  show_instruction1,
  show_instruction2,
  order_sub_type,
  source,
  latitude,
  longitude,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/updatequote/" + id;
  return axios
    .put(
      url,
      {
        lead_id: lead_id,
        // source : source,
        opharma_reference: opharma_reference,
        order_date: order_date,
        prescription_file: prescription_url,
        prescription_file_url: prescription_url,
        // delivery_type : delivery_type,
        // report_file : report_file,
        delivery_charge: delivery_charge,
        comments: comments,
        address_id: address_id,
        address_line1: address_line1,
        address_line2: address_line2,
        city: city,
        country_id: country_id,
        postal_code: postal_code,
        show_instruction1: show_instruction1,
        show_instruction2: show_instruction2,
        channel: channel,
        testing_purpose: testing_purpose,
        institute: institute,
        collector_name: collector_name,
        patient_condition: patient_condition,
        sample_type: sample_type,
        place_of_sample_collection: place_of_sample_collection,
        mode_of_transportation: mode_of_transportation,
        delivery_date: delivery_date,
        delivery_time: delivery_time,
        // created_by : created_by,
        reports: reports,
        shipping_name: name,
        shipping_email: email,
        shipping_mobile: mobileno,
        shipping_phone: phoneno,
        order_status: status,
        margin_type: margin_type,
        margin: margin,
        organization_discount: organization_discount,
        tags: tags,
        paymentoption: paymentoption,
        payment_due_date: payment_due_date,
        order_note: order_note,
        mypharma_reference: mypharma_reference,
        rider_id: rider_id,
        order_sub_type: order_sub_type,
        source: source,
        latitude: latitude,
        longitude: longitude,
        // basket_value : basket_value,
        // total_cost : total_cost,
        // last_subscription_order : last_subscription_order,
        // orderItems : orderItems,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const DeleteOrder = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/orders/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res;
    });
};
export const DeleteSubscriptionOrder = (id, obj) => {
  return axios
    .delete(
      process.env.REACT_APP_NOT_SECRET_CODE + "/subscription_order/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res;
    });
};
export const DeleteLabOrder = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res;
    });
};
export const DeleteUserToken = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/users/token/delete/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res;
    });
};
export const getUserToken = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/users/token/view/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res;
    });
};
export const GetSubscriptionCategory = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions/category", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res;
    });
};
export const RegenerateUserToken = (refresh_token, obj) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/users/token/refresh",
      {
        refresh_token: refresh_token,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res;
    });
};

export const DownloadOrder = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/orders/pdf/" + id, {
      headers: {
        "X-Request-ID": "124",
        "Content-Type": "application/x-www-form-urlencoded",

        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
      // responseType: 'blob',
    })
    .then((res) => {
      return res;
    });
};
export const DownloadDeliveryInvoice = (did, subId, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/subscription_order/pdf/" +
        subId +
        "/" +
        did,
      {
        headers: {
          "X-Request-ID": "124",
          "Content-Type": "application/x-www-form-urlencoded",

          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
        // responseType: 'blob',
      },
    )
    .then((res) => {
      return res;
    });
};

export const DownloadLabOrder = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/pdf/" + id, {
      headers: {
        "X-Request-ID": "124",
        "Content-Type": "application/x-www-form-urlencoded",

        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
      // responseType: 'blob',
    })
    .then((res) => {
      return res;
    });
};
export const getOrders = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/orders", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getallUsers = (
  name,
  email,
  mobile,
  role,
  page,
  country_code,
  obj,
) => {
  var url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/users?name=" +
      name +
      "&email=" +
      email +
      "&mobile=" +
      mobile +
      "&role=" +
      role +
      "&country_code=" +
      country_code;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/users?name=" +
      name +
      "&email=" +
      email +
      "&mobile=" +
      mobile +
      "&page=" +
      page +
      "&role=" +
      role +
      "&country_code=" +
      country_code;
  }
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getuserbyid = (id, obj) => {
  var url = process.env.REACT_APP_NOT_SECRET_CODE + "/users/" + id;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getOrdersbyid = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/orders/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getLabOrdersbyid = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const importLabOrder = (csv, obj) => {};
export const importLead = (csv, obj) => {};
export const importOrder = (csv, obj) => {
  let url = "";

  url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/import/csv";

  return axios
    .post(
      url,
      {
        csv_file: csv,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchOrders = (
  subscriber,
  status,
  rider_id,
  source,
  orderdate,
  payment_type,
  b2b,
  channel,
  order_id,
  po_number,
  from_date,
  to_date,
  page,
  city_id,
  order_type_filter,
  is_courier,
  orderSubType,
  obj,
  sales_user_id,
  // district,
  partial_sent,
  is_claimable,
  store,
  branch,
  delivery_Type,
  total_cost_min,
  total_cost_max,
) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/orders?name=" +
      subscriber +
      " &status=" +
      status +
      "&source=" +
      source +
      "&rider_id=" +
      rider_id +
      "&order_date=" +
      orderdate +
      "&payment_type=" +
      payment_type +
      "&b2b=" +
      b2b +
      "&channel=" +
      channel +
      "&order_id=" +
      order_id +
      "&po_number=" +
      po_number +
      "&from_date=" +
      from_date +
      "&to_date=" +
      to_date +
      "&city_id=" +
      city_id +
      "&order_type=" +
      order_type_filter +
      "&is_courier_partner=" +
      is_courier +
      "&sales_user_id=" +
      sales_user_id +
      //"&district=" +
      //district +
      "&order_sub_type=" +
      orderSubType +
      "&partial_sent=" +
      partial_sent +
      "&is_claimable=" +
      is_claimable +
      "&store=" +
      store +
      "&store_id=" +
      branch +
      "&delivery_type=" +
      delivery_Type +
      "&total_cost_from=" +
      total_cost_min +
      "&total_cost_to=" +
      total_cost_max;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/orders?name=" +
      subscriber +
      " &status=" +
      status +
      "&source=" +
      source +
      "&rider_id=" +
      rider_id +
      "&order_date=" +
      orderdate +
      "&payment_type=" +
      payment_type +
      "&b2b=" +
      b2b +
      "&channel=" +
      channel +
      "&order_id=" +
      order_id +
      "&po_number=" +
      po_number +
      "&from_date=" +
      from_date +
      "&to_date=" +
      to_date +
      "&page=" +
      page +
      "&city_id=" +
      city_id +
      "&order_type=" +
      order_type_filter +
      "&is_courier_partner=" +
      is_courier +
      "&sales_user_id=" +
      sales_user_id +
      "&order_sub_type=" +
      orderSubType +
      "&is_claimable=" +
      is_claimable +
      "&store=" +
      store +
      "&store_id=" +
      branch +
      "&delivery_type=" +
      delivery_Type +
      "&total_cost_from=" +
      total_cost_min +
      "&total_cost_to=" +
      total_cost_max;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchUpcomingOrders = (
  delivery_from_date,
  delivery_to_date,
  obj,
) => {
  let url = "";
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/orders?delivery_from_date=" +
    delivery_from_date +
    "&delivery_to_date=" +
    delivery_to_date;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      console.log(res.data);
      return res.data;
    });
};

export const searchsubscriptionOrders = (page, obj) => {
  let url = "";
  if (page == "") {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscription_order";
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/subscription_order?&page=" +
      page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const SearchLabOrders = (
  subscriber,
  status,
  rider_id,
  orderdate,
  payment_type,
  channel,
  order_id,
  from_date,
  to_date,
  b2b,
  page,
  district,
  is_complete,
  type,
  obj,
) => {
  const params = {
    is_paginate: 1,
    name: subscriber,
    status,
    rider_id: rider_id,
    order_date: orderdate,
    payment_type,
    channel,
    order_id: order_id,
    from_date: from_date,
    to_date: to_date,
    b2b: b2b,
    district: district,
    is_complete: is_complete || undefined,
    type: type,
    ...(page && { page }),
  };

  const queryString = Object.entries(params)
    .filter(([key, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  let url = `${process.env.REACT_APP_NOT_SECRET_CODE}/laborders?${queryString}`;

  console.log("url", url);

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const subscriptionfilter = (package_id, delivery_date, page, obj) => {
  let url = "";
  console.log(package_id, page, obj, "in listfunction");
  if (page == "") {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscription_order_details";
  } else {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscription_order_details";
  }

  return axios
    .post(
      url,
      {
        package_id: package_id,
        delivery_date: delivery_date,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchlastsubscription = (subscriber, page, obj) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE + "/orders?lead_id=" + subscriber;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/orders?lead_id=" +
      subscriber +
      "&page=" +
      page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const searchlastsubscriptionOrder = (subscriber, page, obj) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/subscription_order?lead_id=" +
      subscriber;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/subscription_order?lead_id=" +
      subscriber +
      "&page=" +
      page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const searchLablastsubscription = (subscriber, page, obj) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/laborders?lead_id=" +
      subscriber;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/laborders?lead_id=" +
      subscriber +
      "&page=" +
      page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const searchMedication = (
  item_code,
  title,
  price,
  category_id,
  //add_commision,
  unit_price,
  city,
  is_flash_medicine,
  page,
  is_featured,
  is_available,
  generic_name,
  barcode,
  obj,
) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/medications?item_code=" +
      item_code +
      "&title=" +
      title +
      "&price=" +
      price +
      "&category_id=" +
      category_id /*+
      "&add_commision=" +
      add_commision */ +
      "&unit_price=" +
      unit_price +
      "&city=" +
      city +
      "&is_flash_medicine=" +
      is_flash_medicine +
      "&is_featured=" +
      is_featured +
      "&generic_name=" +
      generic_name +
      "&barcode=" +
      barcode +
      "&is_available=" +
      is_available;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/medications?item_code=" +
      item_code +
      "&title=" +
      title +
      "&price=" +
      price +
      "&category_id=" +
      category_id /*+
      "&add_commision=" +
      add_commision */ +
      "&unit_price=" +
      unit_price +
      "&city=" +
      city +
      "&is_flash_medicine=" +
      is_flash_medicine +
      "&is_featured=" +
      is_featured +
      "&page=" +
      page +
      "&generic_name=" +
      generic_name +
      "&barcode=" +
      barcode +
      "&is_available=" +
      is_available;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const searchReport = (
  item_code,
  title,
  price,
  package_id,
  unit_price,
  page,
  tat,
  tags,
  is_featured,
  report_type,
  obj,
) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/reports?item_code=" +
      item_code +
      "&title=" +
      title +
      "&price=" +
      price +
      "&package_id=" +
      package_id +
      "&unit_price=" +
      unit_price +
      "&tat=" +
      tat +
      "&tags=" +
      tags +
      "&is_featured=" +
      is_featured +
      "&report_type=" +
      report_type;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/reports?item_code=" +
      item_code +
      "&title=" +
      title +
      "&price=" +
      price +
      "&package_id=" +
      package_id +
      "&unit_price=" +
      unit_price +
      "&page=" +
      page +
      "&tat=" +
      tat +
      "&tags=" +
      tags;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const searchMedicationForSubProduct = (title, obj, store) => {
  let url = "";

  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medications?search_medication=" +
    title +
    "&records_per_page=100000000" +
    "&store=" +
    store;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchMedicationForRayaProducts = (title, obj) => {
  let url = "";

  const params = {
    is_featured: "1",
    records_per_page: "100000000",
  };
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    `/medications?${title && "search_medication=" + title}`;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
      params: params,
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchMedicationForOrder = (title, city, page, obj, store) => {
  let baseUrl =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medications?search_medication=" +
    title +
    "&records_per_page=100000000&country=" +
    city;
  if (store !== null && store !== undefined && store !== 1) {
    baseUrl += "&store=" + store;
  }
  return axios
    .get(baseUrl, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchMedicationUsingBarcodeForOrder = (
  title,
  city,
  page,
  obj,
) => {
  let url = "";

  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medications?barcode=" +
    title +
    "&records_per_page=100000000&country=" +
    city;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const searchPackageForOrder = (title, page, obj) => {
  let url = "";

  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/subscriptions?search_package=" +
    title +
    "&records_per_page=100000000";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getCity = (obj, country_id) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/cities/" + country_id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const searchSubscription = (
  tier_name,
  subscription_fees,
  description,
  page,
  obj,
) => {
  let url = "";

  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/subscriptions?tier_name=" +
      tier_name +
      "&subscription_fees=" +
      subscription_fees +
      "&description=" +
      description;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/subscriptions?tier_name=" +
      tier_name +
      "&subscription_fees=" +
      subscription_fees +
      "&description=" +
      description +
      "&page=" +
      page;
  }
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const searchSubscriptionPackage = (
  title,
  description,
  size,
  brand,
  page,
  obj,
) => {
  let url = "";

  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/package/item?title=" +
      title +
      "&description=" +
      description +
      "&size=" +
      size +
      "&brand=" +
      brand;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/package/item?title=" +
      title +
      "&description=" +
      description +
      "&size=" +
      size +
      "&brand=" +
      brand +
      "&page=" +
      page;
  }
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const get_normal_pending_order = (id, obj) => {
  let url = "";

  url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/pending/normal";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const get_express_pending_order = (id, obj) => {
  let url = "";
  url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/pending/express";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const get_single_lead_data = (id, obj) => {
  let url = "";
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/leads?status=3&id=" +
    id +
    "&records_per_page=1";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const searchByorgLeadForOrder = (name, organization, obj) => {
  let url = "";
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/leads?status=3&search_subscriber=" +
    name +
    "&organization_id=" +
    organization +
    "&records_per_page=100000000000";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const searchLeadForOrder = (name, obj) => {
  let url = "";
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/leads?status=3&search_subscriber=" +
    name +
    "&records_per_page=100000000000";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const searchLead = (
  status,
  name,
  mobileno,
  email,
  page,
  country_code,
  obj,
) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/leads?status=" +
      status +
      "&name=" +
      name +
      "&mobile_no=" +
      mobileno +
      "&email=" +
      email +
      "&country_code=" +
      country_code;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/leads?status=" +
      status +
      "&name=" +
      name +
      "&mobile_no=" +
      mobileno +
      "&email=" +
      email +
      "&page=" +
      page +
      "&country_code=" +
      country_code;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const searchLeadForDonor = (value, type, obj) => {
  var url = "";
  if (type == 1) {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/leads?name=" + value;
  } else if (type == 2) {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/leads?mobile_no=" + value;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const searchLeadByName = (name, obj) => {
  var url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/leads?name=" + name + "&page=1";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getb2b = (obj, pg_no) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/b2b?page=" + pg_no, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const getactivitylog = (obj, pg_no, title) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/activities?notes=" +
        title +
        "&page=" +
        pg_no,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const searchB2B = (
  company_name,
  discount,
  delivery_value,
  note,
  page,
  obj,
) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/b2b?company_name=" +
      company_name +
      "&&discount=" +
      discount +
      "&&delivery_value=" +
      delivery_value +
      "&&note=" +
      note;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/b2b?company_name=" +
      company_name +
      "&&discount=" +
      discount +
      "&&delivery_value=" +
      delivery_value +
      "&&note=" +
      note +
      "&page=" +
      page;
  }
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const Addb2b = (
  company_name,
  discount,
  delivery_value,
  note,
  br_number,
  payment_method,
  type,
  address_line_1,
  company_logo,
  contacts,
  deleted_contact_id,
  is_create_b2c,
  parentOrganizationID,
  credit_period,
  is_claimable,
  poolValue,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/b2b";
  return axios
    .post(
      url,
      {
        company_name: company_name,
        discount: discount,
        delivery_value: delivery_value,
        note: note,
        br_number: br_number,
        payment_method: payment_method,
        type: type,
        address_line1: address_line_1,
        company_logo: company_logo,
        contacts: contacts,
        deleted_contact_id: deleted_contact_id,
        is_create_b2c: is_create_b2c,
        parent_org_id: parentOrganizationID,
        credit_period: credit_period,
        is_claimable: is_claimable,
        pool_value: poolValue,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const Deleteb2b = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getb2bdetail = (id, obj) => {
  // console.log(id);
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const updatepaymentinfo = (payment_type, paid_amount, id, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/";
  return axios
    .put(
      url + id + "/status",
      {
        paid_amount: paid_amount,
        payment_type: payment_type,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const updatelabpaymentinfo = (payment_type, paid_amount, id, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/";
  return axios
    .put(
      url + id + "/status",
      {
        paid_amount: paid_amount,
        payment_type: payment_type,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const Updateb2b = (
  company_name,
  discount,
  delivery_value,
  note,
  br_number,
  payment_method,
  type,
  address_line_1,
  id,
  company_logo,
  contacts,
  deleted_contact_id,
  parentOrganizationID,
  credit_period,
  is_claimable,
  poolValue,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/";
  return axios
    .put(
      url + id,
      {
        company_name: company_name,
        discount: discount,
        delivery_value: delivery_value,
        note: note,
        br_number: br_number,
        payment_method: payment_method,
        type: type,
        address_line1: address_line_1,
        company_logo: company_logo,
        contacts: contacts,
        deleted_contact_id: deleted_contact_id,
        parent_org_id: parentOrganizationID,
        credit_period: credit_period,
        is_claimable: is_claimable,
        pool_value: poolValue,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
// Search Couponcode
export const searchCouponCode = (page, obj) => {
  let url = "";
  if (page == "") {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/coupons";
  } else {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/coupons?page=" + page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const deleteCouponCode = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/coupons/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const AddCouponcode = (
  title,
  subtitle,
  description,
  background_color,
  CouponCode,
  discount,
  usage_limit,
  usage_per_customer,
  startdate,
  enddate,
  is_flash_coupon,
  is_active,
  supplier,
  discount_type,
  order_limit,
  code_type,
  tiers,
  tags,
  orgnisation_type,
  obj,
) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/coupons";
  return axios
    .post(
      url,
      {
        title: title,
        subtitle: subtitle,
        description: description,
        partner_id: supplier,
        background_color: background_color,
        coupon_code: CouponCode,
        discount: discount,
        usage_limit: usage_limit,
        usage_per_customer: usage_per_customer,
        start_date: startdate,
        end_date: enddate,
        is_flash_coupon: is_flash_coupon,
        is_active: is_active,
        discount_type: discount_type,
        order_limit: order_limit,
        code_type: code_type,
        tiers: tiers,
        tags: tags,
        orgnisation_type: orgnisation_type,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const getSingleCoupon = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/coupons/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const GetAllPartners = (obj) => {
  let url = "";
  var role = 12;
  url = process.env.REACT_APP_NOT_SECRET_CODE + "/riders/" + role;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const AssignCoupon = (leadid, assign_to_all_users, coupon_id, obj) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/coupons/assign";
  return axios
    .post(
      url,
      {
        lead_id: leadid,
        coupon_id: coupon_id,
        assign_to_all_users: assign_to_all_users,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const CouponHolderList = (couponid, obj) => {
  let url = "";
  var role = 12;
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/coupons/assign/list?coupon_id=" +
    couponid;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const updateCoupons = (
  id,
  title,
  subtitle,
  description,
  background_color,
  CouponCode,
  discount,
  usage_limit,
  usage_per_customer,
  startdate,
  enddate,
  is_flash_coupon,
  is_active,
  discount_type,
  order_limit,
  code_type,
  partner_id,
  tiers,
  tags,
  orgnisation_type,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/coupons/";
  return axios
    .put(
      url + id,
      {
        title: title,
        subtitle: subtitle,
        description: description,
        partner_id: partner_id,
        background_color: background_color,
        coupon_code: CouponCode,
        discount: discount,
        usage_limit: usage_limit,
        usage_per_customer: usage_per_customer,
        start_date: startdate,
        end_date: enddate,
        is_flash_coupon: is_flash_coupon,
        is_active: is_active,
        discount_type: discount_type,
        order_limit: order_limit,
        code_type: code_type,
        discount_type: discount_type,
        partner_id: partner_id,
        tiers: tiers,
        tags: tags,
        orgnisation_type: orgnisation_type,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const redemCoupon = (couponcode, mobile_no, obj) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/coupons/assign/update";
  return axios
    .post(
      url,
      {
        mobile_no: mobile_no,
        coupon_code: couponcode,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const getCouponPartnerWise = (obj) => {
  var url = "";

  url = process.env.REACT_APP_NOT_SECRET_CODE + "/partner/coupons";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getLeadsCouponWise = (id, obj) => {
  var url = "";

  url = process.env.REACT_APP_NOT_SECRET_CODE + "/coupon/leads/" + id;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getSalesRepresentative = (obj) => {
  var url = "";

  url = process.env.REACT_APP_NOT_SECRET_CODE + "/users?is_sales_rep=1";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

// group Api

export const addNewGroup = (
  group_name,
  group_icon,
  is_visible_in_mbe,
  is_visible_in_bulk_pn,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups";
  return axios
    .post(
      url,
      {
        group_name: group_name,
        group_icon: group_icon,
        is_visible_in_mbe: is_visible_in_mbe,
        is_visible_in_bulk_pn: is_visible_in_bulk_pn,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const updateGroup = (
  id,
  group_name,
  group_icon,
  is_visible_in_mbe,
  is_visible_in_bulk_pn,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups/";
  return axios
    .put(
      url + id,
      {
        group_name: group_name,
        group_icon: group_icon,
        is_visible_in_mbe: is_visible_in_mbe,
        is_visible_in_bulk_pn: is_visible_in_bulk_pn,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const DeleteGroup = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res;
    });
};
export const GroupMemberList = (id, obj) => {
  let url = "";
  var role = 12;
  url = process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups/assign/" + id;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const AssignLeadToGroup = (
  leadid,
  group_id,
  send_to_all,
  orgId,
  obj,
) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups/assign";
  /*console.log({
        lead_id:leadid,
        group_id:group_id,
        send_to_all:send_to_all})
        return false;*/
  return axios
    .post(
      url,
      {
        lead_id: leadid,
        group_id: group_id,
        send_to_all: send_to_all,
        organization_id: orgId,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const searchGroup = (page, obj) => {
  let url = "";
  if (page == "") {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups";
  } else {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups?page=" + page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchGrouplead = (
  page,
  is_visible_in_mbe,
  is_visible_in_bulk_pn,
  obj,
) => {
  let url = "";
  if (page == "") {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups";

    if (is_visible_in_mbe == 1 && is_visible_in_bulk_pn == 0) {
      url = url + "?is_visible_in_mbe=" + is_visible_in_mbe;
    } else if (is_visible_in_mbe == 0 && is_visible_in_bulk_pn == 1) {
      url = url + "?is_visible_in_bulk_pn=" + is_visible_in_bulk_pn;
    } else if (is_visible_in_mbe == 1 && is_visible_in_bulk_pn == 1) {
      url =
        url +
        "?is_visible_in_mbe=" +
        is_visible_in_mbe +
        "&is_visible_in_bulk_pn=" +
        is_visible_in_bulk_pn;
    }
  } else {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups?page=" + page;

    if (is_visible_in_mbe == 1 && is_visible_in_bulk_pn == 0) {
      url = url + "&is_visible_in_mbe=" + is_visible_in_mbe;
    } else if (is_visible_in_mbe == 0 && is_visible_in_bulk_pn == 1) {
      url = url + "&is_visible_in_bulk_pn=" + is_visible_in_bulk_pn;
    } else if (is_visible_in_mbe == 1 && is_visible_in_bulk_pn == 1) {
      url =
        url +
        "&is_visible_in_mbe=" +
        is_visible_in_mbe +
        "&is_visible_in_bulk_pn=" +
        is_visible_in_bulk_pn;
    }
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const getSingleGroup = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

// Notification API
// group Api

export const addNewNotification = (
  title,
  content,
  link,
  itemCode,
  discount,
  ext_link,
  token,
) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/notificationTemplates";
  const object = {
    title: title,
    content: content,
    link: link,
    item_code: itemCode,
    discount: discount,
    url: ext_link,
  };
  console.log(object);
  return axios
    .post(url, object, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const DeleteNotificationTemplate = (id, obj) => {
  return axios
    .delete(
      process.env.REACT_APP_NOT_SECRET_CODE + "/notificationTemplates/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res;
    });
};
export const updateNotification = (
  id,
  title,
  content,
  link,
  itemCode,
  discount,
  ext_link,
  token,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/notificationTemplates/";
  return axios
    .put(
      url + id,
      {
        title: title,
        content: content,
        link: link,
        item_code: itemCode,
        discount: discount,
        url: ext_link,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + token,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const getSingleNotification = (id, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + "/notificationTemplates/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const searchNotification = (page, obj) => {
  let url = "";
  if (page == "") {
    url = process.env.REACT_APP_NOT_SECRET_CODE + "/notificationTemplates";
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/notificationTemplates?page=" +
      page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const sendNotification = (
  template_id,
  send_to,
  lead_id,
  group_id,
  gender,
  expire_after,
  package_id,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/notification/send/bulk";
  return axios
    .post(
      url,
      {
        template_id: template_id,
        send_to: send_to,
        lead_id: lead_id,
        group_id: group_id,
        gender: gender,
        expire_after: expire_after,
        catalog_id: package_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const sendNotificationForWatsApp = (
  watsAppText,
  sendTo,
  lead_id,
  packageId,
  whatsApp,
  package_LogoData,
  group_id,
  gender,
  expire_after,
  util_sheet_name,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/notification/send/bulk";
  return axios
    .post(
      url,
      {
        template_name: watsAppText,
        send_to: sendTo,
        lead_id: lead_id,
        catalog_id: packageId,
        whatsApp: whatsApp,
        media_url: package_LogoData,
        group_id: group_id,
        gender: gender,
        expire_after: expire_after,
        util_sheet_name: util_sheet_name,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const sendNotificationForm = (formData, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/notification/send/bulk";
  return axios
    .post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    });
};
export const sendNotificationForminWatsapp = (formData, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/notification/send/bulk";
  return axios
    .post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    });
};

export const getPushNotifications = (obj, number) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        `/notificationInsights?page=${number}`,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};
export const getPushNotification = (id, page, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        `/notificationInsights/${id}?page=${page}`,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const AddMedicationTag = (keyword, category_id, obj, selectTags) => {
  // console.log(obj,medicationcategoryname,wt_commision);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/tags";
  return axios
    .post(
      url,
      {
        keyword: keyword,
        category_id: category_id,
        type: selectTags,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const deleteMedicationTag = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/tags/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getMedicationTagById = (id, obj) => {
  // console.log(id);
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/tags/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const updateMedicationTag = (
  keyword,
  id,
  category_id,
  obj,
  selectTags,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/tags/";
  return axios
    .put(
      url + id,
      {
        keyword: keyword,
        category_id: category_id,
        type: selectTags,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};
export const searchMedicationTags = (keyword, category_id, page, obj) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/tags?category_id=" +
      category_id +
      "&keyword=" +
      keyword;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/tags?category_id=" +
      category_id +
      "&keyword=" +
      keyword +
      "&page=" +
      page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getpagewiseMedicationTag = (page, category_id, obj) => {
  let url = "";

  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/tags?category_id=" +
    category_id +
    "&page=" +
    page;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const gettagstearwise = (value, obj) => {
  let url = "";

  url = process.env.REACT_APP_NOT_SECRET_CODE + "/coupon/tags?tier=" + value;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const getcouponstagwise = (coupon, tiers, userToken) => {
  const url = `${process.env.REACT_APP_NOT_SECRET_CODE}/coupon/relatedTags?tag=${coupon}&tier=${tiers}`;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + userToken,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const DeleteLeads = (data, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups/delete";

  return axios
    .post(url, data, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const ConfirmReceivedQty = (
  id,
  is_full_quantity,
  received_quantity,
  obj,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medication/inventory/" +
    id +
    "/unreceivable/confirm";
  return axios
    .put(
      url,
      {
        is_full_quantity: is_full_quantity,
        received_quantity: received_quantity,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const OrdersCharge = (data, obj) => {
  console.log(data);
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/charge/orders/admin";
  return axios
    .put(
      url,
      {
        order_id: data,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const ChargeLabOrder = (order_id, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/charge/" + order_id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const unReceivable = (obj, title, expirayDate) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medication/inventory/unreceivable/list/?medication_title=" +
        title +
        "&expiary_date=" +
        expirayDate,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const addNewPackage = (
  title,
  duration,
  duration_type,
  description,
  price,
  background_color,
  features,
  user_type,
  package_type,
  insurance,
  insuranceData,
  is_featured,
  free_trial_type,
  free_trial,
  discounted_price,
  product_code,
  country_code,
  package_logo,
  claimPolicyNew,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/cataloguePackage";

  return axios
    .post(
      url,
      {
        title: title,
        description: description,
        duration: duration,
        duration_type: duration_type,
        price: price,
        background_color: background_color,
        features: features,
        user_type: user_type,
        package_type: package_type,
        insurance_id: insurance,
        insuranceData: insuranceData,
        is_featured: is_featured,
        free_trial_type: free_trial_type,
        free_trial: free_trial,
        discounted_price: discounted_price,
        product_code: product_code,
        country_code: country_code,
        package_logo: package_logo,
        policy: claimPolicyNew,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const gatAllOackage = (obj, page) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + `/cataloguePackage?page=${page}`,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const gatAllOackageWithoutPagination = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/packageWithoutPagination", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFilteredPackages = (obj, country_code, packageSearch) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        `/cataloguePackage?country_code=
        ${country_code}&search_package=${packageSearch}`,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deletePackage = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/cataloguePackage/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getPackage = (id, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/cataloguePackage/" + id;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const updatePackage = (
  title,
  description,
  duration,
  duration_type,
  price,
  background_color,
  features,
  insuranceData,
  insurance,
  user_type,
  package_type,
  is_featured,
  free_trial,
  free_trial_type,
  discounted_price,
  product_code,
  country_code,
  package_logo,
  claimPolicy,
  deleteClaimPolicy,
  obj,
  id,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/cataloguePackage/";
  return axios
    .put(
      url + id,
      {
        title: title,
        description: description,
        duration: duration,
        duration_type: duration_type,
        price: price,
        background_color: background_color,
        features: features,
        insuranceData: insuranceData,
        insurance_id: insurance,
        user_type: user_type,
        package_type: package_type,
        is_featured: is_featured,
        free_trial: free_trial,
        free_trial_type: free_trial_type,
        discounted_price: discounted_price,
        product_code: product_code,
        country_code: country_code,
        package_logo: package_logo,
        policy_delete: deleteClaimPolicy,
        policy_new: claimPolicy,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const addDelivery_type = (
  label,
  value,
  charge,
  within,
  delivery_type_id,
  city_info,
  ordertype,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/deliverytypes";

  return axios
    .post(
      url,
      {
        delivery_type_label: label,
        delivery_type_value: value,
        delivery_charges: charge,
        delivery_within: within,
        delivery_type_id: delivery_type_id,
        city_id: city_info,
        order_type: ordertype,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const getAllDelivery_type = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/deliverytypes", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteDelivery_type = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/deliverytypes/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDelivery_type = (id, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/deliverytypes/" + id;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const updateDelivery_type = (
  label,
  value,
  charge,
  within,
  delivery_type_id,
  city,
  ordertype,
  obj,
  id,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/deliverytypes/";
  return axios
    .put(
      url + id,
      {
        delivery_type_label: label,
        delivery_type_value: value,
        delivery_charges: charge,
        delivery_within: within,
        delivery_type_id: delivery_type_id,
        city_id: city,
        order_type: ordertype,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      //  console.log(res);
    });
};

export const assignPackage = (
  organization_id,
  package_id,
  assignGroup,
  package_title,
  obj,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/cataloguePackage/organization/assign";
  return axios
    .post(
      url,
      {
        organization_id: organization_id,
        package_id: package_id,
        assign_group: assignGroup,
        package_title: package_title,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const getassignedPackage = (package_id, obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/cataloguePackage/organization/assign/" +
    package_id;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const outofstockorder = (id, obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medications/update/outofstock_status/" +
    id;
  return axios
    .put(
      url,
      { is_out_of_stock: 1 },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const restockorder = (id, obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medications/update/outofstock_status/" +
    id;
  return axios
    .put(
      url,
      { is_out_of_stock: 0 },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const getallmedicationpackages = (obj, page) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/medicationpackages?package_code";
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/medicationpackages?package_code=" +
      "&page=" +
      page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchMedicationPackage = (
  package_code,
  package_name,
  price,
  page,
  obj,
) => {
  let url = "";
  if (page == "") {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/medicationpackages?package_code=" +
      package_code +
      "&package_name=" +
      package_name +
      "&price=" +
      price;
  } else {
    url =
      process.env.REACT_APP_NOT_SECRET_CODE +
      "/medicationpackages?package_code=" +
      package_code +
      "&package_name=" +
      package_name +
      "&price=" +
      price +
      "&page=" +
      page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const AddMedicationPackage = (package_name, price, inputlist, obj) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/medicationpackages";

  return axios
    .post(
      url,
      {
        package_name: package_name,
        price: price,
        medications: inputlist,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const EditMedicationPackage = (
  package_name,
  price,
  package_id,
  inputlist,
  obj,
) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/medicationpackages/" + package_id;

  return axios
    .put(
      url,
      {
        package_name: package_name,
        price: price,
        medications: inputlist,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const DeleteMedicationPackage = (id, obj) => {
  return axios
    .delete(
      process.env.REACT_APP_NOT_SECRET_CODE + "/medicationpackages/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetMedicationPackage = (obj, package_id) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medicationpackages/" +
        package_id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const Get_Medication_commision = (obj) => {
  return axios.get(
    process.env.REACT_APP_NOT_SECRET_CODE +
      "/settings/find/medication_commision",
    {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    },
  );
};

export const searchSpeciality = (obj) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/specialities";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const addSpeciality = (
  obj,
  speciality_name,
  speciality_icon_data,
  description,
  call_duration,
  consultation_fee,
  chargeType,
) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/specialities";

  return axios
    .post(
      url,
      {
        title: speciality_name,
        speciality_icon: speciality_icon_data,
        description: description,
        call_duration: call_duration,
        consultation_fee: consultation_fee,
        charge_type: chargeType,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const EditSpeciality = (
  obj,
  id,
  package_name,
  speciality_icon,
  description,
  call_duration,
  consultation_fee,
  chargeType,
) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/specialities/" + id;

  return axios
    .put(
      url,
      {
        title: package_name,
        speciality_icon: speciality_icon,
        description: description,
        call_duration: call_duration,
        consultation_fee: consultation_fee,
        charge_type: chargeType,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const DeleteSpeciality = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/specialities/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetSpeciality = (obj, id) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/specialities/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const ChangeSpecialityStatus = (id, status, obj) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/specialities/status/" +
        id +
        "/" +
        status,
      {},
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const removeassigedorg = (org_id, package_id, obj) => {
  return axios
    .delete(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/cataloguePackage/organization/remove",
      {
        data: {
          organization_id: org_id,
          package_id: package_id,
        },
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetGlobalSchedules = (obj, id) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/globalSchedules/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const GetAllGlobalSchedules = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/globalSchedules", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const AddGlobalSchedules = (
  obj,
  gs_date,
  is_holiday,
  is_hallmark_day,
) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/globalSchedules";

  return axios
    .post(
      url,
      {
        gs_date: gs_date,
        is_holiday: is_holiday,
        is_hallmark_day: is_hallmark_day,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const UpdateGlobalSchedules = (
  obj,
  id,
  gs_date,
  is_holiday,
  is_hallmark_day,
) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/globalSchedules/" + id,
      {
        gs_date: gs_date,
        is_holiday: is_holiday,
        is_hallmark_day: is_hallmark_day,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const DeleteGlobalSchedules = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/globalSchedules/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetSchedule = (obj, id) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/doctorSchedule/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const GetAllSchedule = (obj, page) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + "/doctorSchedule?page=" + page,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const AddNewSchedule = (obj, doctor_id, slots, holidays) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/doctorSchedule/save";

  return axios
    .post(
      url,
      {
        doctor_id: doctor_id,
        slots: slots,
        holidays: holidays,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const UpdateSchedule = (obj, id, doctor_id, slot_id, holidays) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/doctorSchedule/" + id,
      {
        doctor_id: doctor_id,
        slots: slot_id,
        holidays: holidays,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetDocAllUser = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/users", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const DeleteDocSchedules = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/doctorSchedule/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const CataloguePackageActivity = (data, page, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/cataloguePackageActivities?search_text=" +
        data +
        "&page=" +
        page,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const ViewConsultations = (
  obj,
  doctor_id,
  patient_id,
  consultation_mode,
  call_ended_type,
  page,
) => {
  var url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/consultations?doctor_id=" +
    doctor_id +
    "&patient_id=" +
    patient_id +
    "&consultation_mode=" +
    consultation_mode +
    "&call_ended_type=" +
    call_ended_type;
  if (page != "") {
    url = url + "&page=" + page;
  }

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const DownloadConsultationInvoice = (fa_id, id, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/consultations/pdf/" +
        fa_id +
        "/" +
        id,
      {
        headers: {
          "X-Request-ID": "124",
          "Content-Type": "application/x-www-form-urlencoded",

          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
        // responseType: 'blob',
      },
    )
    .then((res) => {
      return res;
    });
};

export const rechargePayment = (obj, id) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/consultations/charge/" + id,
      {},
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getallDonorList = (
  donor_name,
  donor_email,
  donor_mobile,
  page,
  obj,
) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/doners?name=" +
        donor_name +
        "&email=" +
        donor_email +
        "&mobile=" +
        donor_mobile +
        "&page=" +
        page,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getallDonorVoucherList = (created_at, page, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/voucherdoners?donation_date=" +
        created_at +
        "&page=" +
        page,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const searchBanner = (obj) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/banners";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const addBanner = (obj, Banner_name, Banner_icon_data, is_featured) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/banners";

  return axios
    .post(
      url,
      {
        title: Banner_name,
        banner_url: Banner_icon_data,
        is_featured: is_featured,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const EditBanner = (obj, id, package_name, Banner_icon, is_featured) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/banners/" + id;

  return axios
    .put(
      url,
      {
        title: package_name,
        banner_url: Banner_icon,
        is_featured: is_featured,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const DeleteBanner = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/banners/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetBanner = (obj, id) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/banners/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const addAppointment = (
  obj,
  doctor_id,
  appointment_datetime,
  card_detail_id,
) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/customer/firstadvice/appointments/create";

  return axios
    .post(
      url,
      {
        doctor_id: doctor_id,
        appointment_datetime: appointment_datetime,
        card_detail_id: card_detail_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const editAppointment = (
  obj,
  id,
  doctor_id,
  appointment_datetime,
  card_detail_id,
) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/customer/firstadvice/appointments/create/" +
    id;

  return axios
    .put(
      url,
      {
        doctor_id: doctor_id,
        appointment_datetime: appointment_datetime,
        card_detail_id: card_detail_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchAppointment = (
  obj,
  page,
  appointment_date,
  apt_status,
  doctor,
  patient,
  payment_status,
) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/appointments?page=" +
    page +
    "&payment_status=" +
    payment_status +
    "&appointment_date=" +
    appointment_date +
    "&status=" +
    apt_status +
    "&patient_name=" +
    patient +
    "&doctor_name=" +
    doctor;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const GetAppointment = (obj, id) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/customer/firstadvice/appointments/" +
        id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const getDoctorSchByDate = (obj, id, appointment_date) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/doctorSchedule/" + id + "/date";

  return axios
    .post(
      url,
      {
        appointment_date: appointment_date,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const DeleteAppointment = (obj, id, cancel_reason) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/appointment/" + id + "/cancel",
      {
        cancel_reason: cancel_reason,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateAptDoctor = (obj, id, doctor_id, appointment_date) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/appointment/" +
        id +
        "/update/doctor",
      {
        doctor_id: doctor_id,
        appointment_date: appointment_date,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const resheduleAppointment = (obj, id, appointment_date) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/appointment/" +
        id +
        "/reschedule",
      {
        appointment_date: appointment_date,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const saveXeroInvioce = (obj, from_date, to_date, order_id) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/orders/xero/save",
      {
        from_date: from_date,
        to_date: to_date,
        order_id: order_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const uploadbulkinventry = (formData, obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medications/inventory/upload/excel";
  return axios
    .post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const getVoucher = (obj, id) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/vouchers/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getAllVoucher = (obj, page, title) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/vouchers?page=" +
        page +
        "&title=" +
        title,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const addVoucher = (
  obj,
  title,
  description,
  price,
  background_color,
) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/vouchers";
  return axios
    .post(
      url,
      {
        title: title,
        description: description,
        price: price,
        background_color: background_color,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const updateVoucher = (
  obj,
  id,
  title,
  description,
  price,
  background_color,
) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/vouchers/" + id,
      {
        title: title,
        description: description,
        price: price,
        background_color: background_color,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteVoucher = (obj, id) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/vouchers/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const addVoucherDoner = (
  obj,
  name,
  mobile,
  email,
  payment_method,
  amount,
  payment_date,
) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/doner/save";
  return axios
    .post(
      url,
      {
        name: name,
        mobile: mobile,
        payment_method: payment_method,
        email: email,
        amount: amount,
        payment_date: payment_date,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const DeleteVoucherDoner = (obj, id) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/doners/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getRiderDistance = (obj, id) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/orders/rider/distance?rider_id=" +
        id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const getallTicket = (obj, page, status) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/ticket?page=" +
        page +
        "&filter=" +
        status,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const getTickets = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/ticket/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const addNewTicket = (obj, fdata) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/ticket";
  return axios
    .post(url, fdata, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const UpdateNewTicket = (obj, fdata, id) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/ticket/" + id;
  return axios
    .post(url, fdata, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const UpdateNewTicketRow = (
  obj,
  lead_id,
  severity,
  platform,
  type,
  description,
  attached_files,
  status,
  id,
) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/ticketraw/" + id;
  return axios
    .post(
      url,
      {
        lead_id: lead_id,
        severity: severity,
        platform: platform,
        type: type,
        description: description,
        files: attached_files,
        status: status,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const DeleteTicket = (obj, id) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/ticket/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const UpdateTicketStatus = (obj, tickets, email_body) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/ticket/bulkupdate";
  return axios
    .put(
      url,
      {
        tickets: tickets,
        email_body: email_body,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const getDocTimeSlots = (obj, doc, apt_date) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/doctorSchedule/" +
    doc +
    "/date?appointment_date=" +
    apt_date;
  return axios
    .post(
      url,
      {},
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const deleteInventory = (obj, id) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/medication/inventory/" + id;

  return axios
    .delete(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getAllPoList = (
  obj,
  number,
  searchParam,
  status,
  from,
  to,
  store_id,
  branch,
) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        `/purchaseorder?page=${number}&search=${searchParam}&order_status=${status}&from_date=${from}&to_date=${to}&store_id=${store_id}&branch=${branch}`,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const downloadingPurchaseOrder = (obj, id) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + `/purchaseorders/pdf/` + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const searchMedicationForPurchaseOrder = (title, obj) => {
  let url = "";

  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medications?search_medication=" +
    title +
    "&records_per_page=100000000&country=1";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchMedicationBarcodeForPurchaseOrder = (barcode, obj) => {
  let url = "";

  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/medications?barcode=" +
    barcode +
    "&records_per_page=100000000&country=1";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const AddPurchaseOrder = (AddPoBody, obj) => {
  console.log(AddPoBody);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/purchaseorder";
  return axios
    .post(
      url,
      AddPoBody,

      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => err);
};

export const GetPoListById = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/purchaseorder/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

// export const AddToInventory = (attachment, poId, addToInventoryValues, obj) => {
//   const url =
//     process.env.REACT_APP_NOT_SECRET_CODE + "/purchaseorder/add/inventory";
//   const fdata = new FormData();
//   fdata.append("attachment", attachment);
//   fdata.append("purchase_order_id", Number(poId));
//   addToInventoryValues.forEach((item, index) => {
//     fdata.append(`order_items[${index}][id]`, item.id);
//     fdata.append(`order_items[${index}][selling_price]`, item.selling_price);
//     fdata.append(`order_items[${index}][unit_price]`, item.unit_price);
//     fdata.append(`order_items[${index}][batch_no]`, item.batch_no);
//     fdata.append(`order_items[${index}][expiry_date]`, item.expiary_date);
//     fdata.append(`order_items[${index}][unit_price]`, item.unit_price);
//     fdata.append(
//       `order_items[${index}][is_goods_received]`,
//       item.isGoodReceived,
//     );
//   });
//   return axios
//     .post(
//       url,
//       fdata,

//       {
//         headers: {
//           Authorization: "Bearer " + obj,
//           "Content-Type": "application/json",
//           "X-Request-ID": "124",
//           "X-Country-Code": "BD",
//           "X-Client-Name": "WEBSITE",
//           "X-Client-Version": "123",
//         },
//       },
//     )
//     .then((res) => {
//       return res;
//     })
//     .catch((error) => {
//       return error.response.data;
//     });
// };
export const AddToInventory = (
  attachment,
  poId,
  addToInventoryValues,
  storeId,
  obj,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/purchaseorder/add/inventory";
  const fdata = new FormData();
  fdata.append("attachment", attachment);
  fdata.append("purchase_order_id", Number(poId));
  fdata.append("store_id", Number(storeId));

  addToInventoryValues.forEach((item, index) => {
    if (!item.batches || item.batches.length === 0) {
      const randomBatchNo =
        "BN-" +
        Math.floor(Math.random() * 1000000000)
          .toString()
          .padStart(9, "0");
      const batchObj = {
        medi_id: item.id, // API expects medi_id
        batch_no: randomBatchNo,
        qty: item.pendingQty || item.requestQty || item.quantity || 0,
        expiry_date: item.expiary_date || null,
      };
      item.batches = [batchObj];
    }
    fdata.append(`order_items[${index}][id]`, item.id);
    fdata.append(`order_items[${index}][selling_price]`, item.selling_price);
    fdata.append(`order_items[${index}][unit_price]`, item.unit_price);
    // fdata.append(`order_items[${index}][batch_no]`, item.batch_no);
    fdata.append(`order_items[${index}][expiry_date]`, item.expiary_date);
    fdata.append(
      `order_items[${index}][is_goods_received]`,
      item.isGoodReceived,
    );

    // Append batch array
    if (Array.isArray(item.batches)) {
      item.batches.forEach((batch, bIndex) => {
        fdata.append(
          `order_items[${index}][batch][${bIndex}][med_id]`,
          batch.medi_id,
        );
        fdata.append(
          `order_items[${index}][batch][${bIndex}][batch_no]`,
          batch.batch_no,
        );
        fdata.append(
          `order_items[${index}][batch][${bIndex}][quantity]`,
          batch.qty || batch.quantity,
        );
        fdata.append(
          `order_items[${index}][batch][${bIndex}][expiry_date]`,
          batch.expiry_date,
        );
      });
    }
  });

  return axios
    .post(url, fdata, {
      headers: {
        Authorization: "Bearer " + obj,
        "Content-Type": "multipart/form-data", // important for FormData
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
      },
    })
    .then((res) => res)
    .catch((error) => error.response.data);
};

export const UpdatePurchaseOrder = async (fdata, obj, id) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/purchaseorder/edit/" +
    id +
    "?_method=PUT";
  try {
    const res = await axios.post(url, fdata, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};
export const DeletePurchaseOrder = async (id, obj) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/purchaseorder/" + id;
  try {
    const res = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const StatusCheck = async (obj) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/purchaseorders/statusal";
  try {
    const res = await axios.get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const SendToXero = async (obj, id) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/purchaseorder/sentXero/" + id;
  try {
    const res = await axios.post(
      url,
      {},
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    );
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const RemoveAttachment = async (obj, id, name) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/purchaseorder/deleteFile/" +
    id +
    "?name=" +
    name;
  try {
    const res = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const GetAllUserForDoctorEarnings = (obj, number, name) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/users?page=" +
        number +
        "&role=9&name=" +
        name,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const getDoctorEarningHistoryById = (obj, id) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + `/docEarnings/${id}`, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getTotalDoctorEarningById = (obj, id) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + `/docEarnings?doctor_id=${id}`,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const redeemDoctorEarning = async (doctorEarningsRedeemBody, obj) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/redeem/docEarnings";
  try {
    const res = await axios.post(url, doctorEarningsRedeemBody, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const LoginLightHouse = async (loginCredentials) => {
  let url = process.env.REACT_APP_LIGHT_HOUSE_API + "/login";
  try {
    const res = await axios.post(url, loginCredentials, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json ",
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const GetAllLightHouseCategories = (token, number) => {
  return axios
    .get(process.env.REACT_APP_LIGHT_HOUSE_API + "/category?page=" + number, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const addLightHouseCategory = async (addCategoryTitleBody, token) => {
  let url = process.env.REACT_APP_LIGHT_HOUSE_API + "/category";
  try {
    const res = await axios.post(url, addCategoryTitleBody, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + token,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const GetCategoriesById = (token, id) => {
  return axios
    .get(process.env.REACT_APP_LIGHT_HOUSE_API + "/category/" + id, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const updateLightHouseCategory = async (
  updatwCategoryTitleBody,
  id,
  token,
) => {
  let url = process.env.REACT_APP_LIGHT_HOUSE_API + "/category/" + id;
  try {
    const res = await axios.put(url, updatwCategoryTitleBody, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json ",
        Authorization: "Bearer " + token,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const deleteLightHouseCategory = async (token, id) => {
  let url = process.env.REACT_APP_LIGHT_HOUSE_API + "/category/" + id;
  try {
    const res = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json ",
        Authorization: "Bearer " + token,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const GetAllLightHouseTemplates = (token, number) => {
  return axios
    .get(process.env.REACT_APP_LIGHT_HOUSE_API + "/template?page=" + number, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const addLightHouseTemplate = async (addTemplateBody, token) => {
  let url = process.env.REACT_APP_LIGHT_HOUSE_API + "/template";
  try {
    const res = await axios.post(url, addTemplateBody, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + token,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const getTemplateById = (token, id) => {
  return axios
    .get(process.env.REACT_APP_LIGHT_HOUSE_API + "/template/" + id, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const updateLightHouseTemplate = async (
  updateLightHouseTemplateBody,
  id,
  token,
) => {
  let url = process.env.REACT_APP_LIGHT_HOUSE_API + "/template/" + id;
  try {
    const res = await axios.put(url, updateLightHouseTemplateBody, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json ",
        Authorization: "Bearer " + token,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const deleteLightHouseTemplate = async (token, id) => {
  let url = process.env.REACT_APP_LIGHT_HOUSE_API + "/template/" + id;
  try {
    const res = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json ",
        Authorization: "Bearer " + token,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const GetAllLightHouseSubCategory = (token, number) => {
  return axios
    .get(
      process.env.REACT_APP_LIGHT_HOUSE_API + "/subcategory?page=" + number,
      {
        headers: {
          "Content-Type": "application/json ",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const GetAllLightHouseCategoriesWithoutPagination = (token) => {
  return axios
    .get(process.env.REACT_APP_LIGHT_HOUSE_API + "/categoryList", {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const GetAllLightHouseTemplatesWithoutPagination = (token) => {
  return axios
    .get(process.env.REACT_APP_LIGHT_HOUSE_API + "/templateList", {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const addLightHouseSubCategory = async (addSubCategoryBody, token) => {
  let url = process.env.REACT_APP_LIGHT_HOUSE_API + "/subcategory";
  try {
    const res = await axios.post(url, addSubCategoryBody, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + token,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const getSubCategoriesById = (token, id) => {
  return axios
    .get(process.env.REACT_APP_LIGHT_HOUSE_API + "/subcategory/" + id, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const updateLightHouseSubCategory = async (
  updateLightHouseSubCategoryBody,
  id,
  token,
) => {
  let url = process.env.REACT_APP_LIGHT_HOUSE_API + "/subcategory/" + id;
  try {
    const res = await axios.put(url, updateLightHouseSubCategoryBody, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json ",
        Authorization: "Bearer " + token,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const deleteLightHouseSubCategories = async (token, id) => {
  let url = process.env.REACT_APP_LIGHT_HOUSE_API + "/subcategory/" + id;
  try {
    const res = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json ",
        Accept: "application/json ",
        Authorization: "Bearer " + token,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const getAllGroupDataForProductCatalogue = (obj) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getCallLogsById = (token, id) => {
  return axios
    .get(
      process.env.REACT_APP_CONSULT_API +
        "consultation-activity-log/consultation/" +
        id,
      {
        headers: {
          "Content-Type": "application/json ",
          Accept: "application/json",
          Authorization: "Bearer " + token,
          "X-Request-Id": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const moveToExpiryMedicine = (
  expiaryMedicationId,
  expiryDate,
  expiryQuantity,
  userId,
  obj,
) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/medication/inventory/move/expiry";
  return axios
    .post(
      url,
      {
        medication_id: expiaryMedicationId,
        expiry_date: expiryDate,
        quantity: expiryQuantity,
        logged_id: userId,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};
export const GetAllExpiryMedicineData = (token, number) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medication/inventory/expiry?page=" +
        number,
      {
        headers: {
          "Content-Type": "application/json ",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const GetAllClaimData = (
  token,
  number,
  orderId,
  fromDate,
  toDate,
  status,
  organisationId,
  claimId,
  claimType,
  getLeadName,
) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/claim?page=" +
        number +
        "&order_id=" +
        orderId +
        "&from_date=" +
        fromDate +
        "&to_date=" +
        toDate +
        "&status=" +
        status +
        "&org_id=" +
        organisationId +
        "&claim_id=" +
        claimId +
        "&type=" +
        claimType +
        "&lead_name=" +
        getLeadName,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const updateClaim = (obj, id, updateClaimBody) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/claim/update/" + id;
  return axios
    .post(url, updateClaimBody, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const retryClaimApproval = (obj, body) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/claims/validate/rerun";
  return axios
    .post(url, body, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getAvailableCreditsByLeads = (id, creditType, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/leadsbalance/" +
        id +
        "?type=" +
        creditType,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const completeClaimBulk = (obj, completeClaimBody) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/claim/bulk/complete/";
  return axios
    .post(url, completeClaimBody, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getPolicyDetailsById = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/claim/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const addCountry = async (obj, countrybody) => {
  return axios
    .post(process.env.REACT_APP_NOT_SECRET_CODE + "/countries", countrybody, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getPolicyDetailsByPackgeId = (obj, packageId, policytype) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/claim/policy/type?claim_type=" +
        policytype +
        "&package_id=" +
        packageId,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const getOrganizationDataWithoutPagination = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/b2bListWithoutPagination", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const exportClaimDataOrganizationWise = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/claims/export/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const exportClaimDataOrganizationWiseForSuperAdmin = (id, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/claims/exportForSuperAdmin/" +
        id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("err", err);
      return err;
    });
};

export const getBrachDetailsCountryCodeWise = (countryCode, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/pharmacies?country=" +
        countryCode,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getStoreWise = (countryCode, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/pharmacies?country=" +
        countryCode +
        "&type=warehouse",
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const GetAllDoctors = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/getdoctors", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const GetAllChildCompanyList = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/subCompanies", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const offlineCallStatusChange = (obj, id, status) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/appointment/" + id + "/offline",
      {
        status: status,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      // console.log(err);
    });
};
export const GetPreviousPurchaseOrderData = (id, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + "/purchaseorder/previous/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetPurchaseOrderHistorydataSupplierWise = (id, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + "/purchaseorder/history/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetClaimFamilyDetails = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/family/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const GetPredictUrl = (id) => {
  return axios
    .get(process.env.REACT_APP_PREDICT_ANALYTICS_API + "predict/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer ",
      },
    })
    .then((res) => {
      console.log(res + "response");
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const GetAiaUserList = (obj, mobileno) => {
  let url = "";
  url = process.env.REACT_APP_NOT_SECRET_CODE + "/aia-users?search=" + mobileno;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const subscribeToTopic = (bearerToken, body) => {
  return axios
    .post(process.env.REACT_APP_NOT_SECRET_CODE + "/storegeneraltoken", body, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + bearerToken,
      },
    })
    .then((res) => {
      return res;
      // console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getCreditNoteByOrder = (obj, id) => {
  console.log("sdfsdfsdfsdf");
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/credit-note/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      console.log(res + "response");
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteCreditNote = (id, obj) => {
  // console.log(process.env.REACT_APP_NOT_SECRET_CODE + "/credit-note/" + id);
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/credit-note/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res;
    });
};

export const CreateCreditNote = (obj, createCreditNoteBody) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/credit-note";
  return axios
    .post(url, createCreditNoteBody, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const UpdateCreditNote = (obj, createCreditNoteBody) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/credit-note/" +
    createCreditNoteBody.cn_id;
  return axios
    .put(url, createCreditNoteBody, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const ApprovedCreditNote = (obj, cn_id) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + `/credit-note/${cn_id}/update`;
  return axios
    .put(
      url,
      {
        status: "APPROVED",
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const getAllUtilData = (utils, obj) => {
  console.log("---obj---", utils);
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/order/edit/utils";
  return axios
    .post(
      url,
      { utils },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const getRemainingCredits = (lead_id, obj) => {
  return axios
    .get(`${process.env.REACT_APP_NOT_SECRET_CODE}/leadsbalance/${lead_id}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: `Bearer ${obj}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error("Error fetching remaining credits:", error);
      throw error;
    });
};

export const getAllStores = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/getstores", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const allocationValuePopUp = (id, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + "/allocated/medication/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const submitInsuremeClaimRequest = (
  orderId,
  claim_amount,
  lead_id,
  obj,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    `/insureme/claim/request?order_id=${orderId}`;
  return axios
    .post(
      url,
      { claim_amount, lead_id },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const submitInsuremeClaimConfirmation = (order_id, obj) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    `/insureme/claim/confirmation?order_id=${order_id}`;
  return axios
    .post(
      url,
      {},
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const insuremeUploadDocument = async (fdata, obj) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/insureme/document/upload";
  try {
    const res = await axios.post(url, fdata, {
      headers: {
        "Content-Type": "multipart/form-data ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};
export const downloadOrderPdf = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/orders/temporarypdf/" + id, {
      headers: {
        "X-Request-ID": "124",
        "Content-Type": "application/x-www-form-urlencoded",

        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const DownloadCreditNote = (cn_id, obj) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + "/credit-note/" + cn_id + "/pdf",
      {
        headers: {
          "X-Request-ID": "124",
          "Content-Type": "application/x-www-form-urlencoded",

          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
        // responseType: 'blob',
      },
    )
    .then((res) => {
      return res;
    });
};

export const PredictClaimBills = (bill_url) => {
  const url = "https://aia-status.flash.health/find_similar";
  // const bb = process.env.BILL_URL_PREDICT_API
  // console.log(">>>>>>>>>>>>>>>>>>>>>>",bb);

  return axios
    .post(
      url,
      { bill_url },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.error("Error in PredictClaimBills:", err.response || err);
      throw err;
    });
};
export const submitManualClaim = (claimData, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/claim";
  return axios
    .post(
      url,
      claimData,

      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => err);
};
// export const Prescription_Upload = (obj) => {

//   const url = process.env.REACT_APP_NOT_SECRET_CODE + "/claim/prescription_upload";
//   return axios
//     .post(
//       url,
//       {
//         headers: {
//           "Content-Type": "application/json ",
//           "X-Request-ID": "124",
//           "X-Country-Code": "BD",
//           "X-Client-Name": "WEBSITE",
//           "X-Client-Version": "123",
//           Authorization: "Bearer " + obj,
//         },
//       }
//     )
//     .then((res) => {
//       return res;
//     })
//     .catch((err) => err);
// };
export const Bills_Upload = (obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/claim/bill_upload";
  return axios
    .post(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => err);
};

export const getOrganizationDetails = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/subCompanies", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const searchGetLeads = (name, obj) => {
  let url = "";
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/searchLeads?status=3&search_subscriber=" +
    name +
    "&records_per_page=100000000000";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getClaimPointsDetails = (obj, lead_id) => {
  const endPoint = `${process.env.REACT_APP_NOT_SECRET_CODE}/claimpoints?lead_id=${lead_id}`;
  return axios
    .get(endPoint, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const getAllOrganizationWiseLeads = (obj) => {
  let url = "";

  url = process.env.REACT_APP_NOT_SECRET_CODE + "/organizationwiseleads";

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const CreateLeads = (
  obj,
  name,
  mobile_no,
  date_of_birth,
  parent_org_id,
  full_name,
  bank_name,
  bank_branch,
  bank_account_no,
  email,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/organizationwiseleadscreate";
  return axios.post(
    url,
    {
      name: name,
      mobile_no: mobile_no,
      // remainingCredit: remainingCredit,
      date_of_birth: date_of_birth,
      parent_org_id: parent_org_id,
      full_name: full_name,
      bank_name: bank_name,
      bank_branch: bank_branch,
      bank_account_no: bank_account_no,
      email: email,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    },
  );
};
export const deleteLeads = (id, obj) => {
  return axios
    .delete(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/deleteorganizationwiselead/" +
        id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const CreateTags = (keyword, obj, claims) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/tags";
  return axios
    .post(
      url,
      {
        keyword: keyword,
        type: claims,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const getClaimTag = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/get-tags?type=b2b", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const submitB2bTag = (obj, tagPayload) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/assign-tags";
  return axios

    .post(url, tagPayload, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const RemoveFlashCredits = (
  user_id,
  points,
  note_title,
  credit_type,
  note_description,
  // is_flash_voucher,
  org_id,
  obj,
) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/removecredit";
  return axios
    .post(
      url,
      {
        user_id: user_id,
        points: points,
        credit_type: credit_type,
        note_title: "Reset Balance",
        note_description: "Clears the claim wallet balance",
        // is_flash_voucher: is_flash_voucher,
        org_id: org_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};
export const AddToInventoryStock = (
  store_id,
  attachment,
  poId,
  addToInventoryValues,
  obj,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/purchaseorder/add/inventory-store-wise";
  const fdata = new FormData();
  fdata.append("store_id", store_id);
  fdata.append("attachment", attachment);
  fdata.append("purchase_order_id", Number(poId));
  addToInventoryValues.forEach((item, index) => {
    fdata.append(`order_items[${index}][id]`, item.id);
    fdata.append(`order_items[${index}][selling_price]`, item.selling_price);
    fdata.append(`order_items[${index}][unit_price]`, item.unit_price);
    fdata.append(`order_items[${index}][batch_no]`, item.batch_no);
    fdata.append(`order_items[${index}][expiry_date]`, item.expiary_date);
    fdata.append(`order_items[${index}][unit_price]`, item.unit_price);
    fdata.append(
      `order_items[${index}][is_goods_received]`,
      item.isGoodReceived,
    );
  });
  return axios
    .post(
      url,
      fdata,

      {
        headers: {
          Authorization: "Bearer " + obj,
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error.response.data;
    });
};
export const completeOrderStatus = (obj, store, id) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/order/complete/" + id;
  return axios
    .post(
      url,
      {
        store_id: store,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    });
};

export const getAllMedication = (obj, store) => {
  return axios
    .get(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/medications/all?store=${store}`,
      {
        headers: {
          Authorization: "Bearer " + obj,
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const storeOrderComment = (obj, commentPayload) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/order-comments";
  return axios

    .post(url, commentPayload, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const getOrderWiseComment = (obj, id, type) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/order-comments/" +
    id +
    "?type=" +
    type;
  return axios

    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const deleteOrderWiseComment = (obj, id) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/order-comments/" + id;
  return axios

    .delete(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const getStatusLogsByOrderId = (obj, id) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/status-logs/" + id;
  return axios

    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const getAllSpecialty = (obj) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/get-all-specialties/";
  return axios

    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const getAllUsersWithOutPagination = (obj) => {
  var url =
    process.env.REACT_APP_NOT_SECRET_CODE + "/getAllUsersWithout_Pagination";
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const createAddress = (obj, addressPayload, lead_id) => {
  let url = `${process.env.REACT_APP_NOT_SECRET_CODE}/leads/${lead_id}`;
  return axios
    .post(url, addressPayload, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const AddToInventoryStockStoreWise = ({
  store_id,
  medication_id,
  obj,
  quantity,
  expiry_date,
  unit_price,
  batch_no,
  note,
  receivable_date,
  is_goods_received,
  quantity_type,
  quantity_per_box,
  xcoord,
  ycoord,
  batches,
}) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/medication/inventory";

  return axios.post(
    url,
    {
      store_id,
      medication_id,
      expiry_date,
      quantity,
      unit_price,
      batch_no,
      note,
      receivable_date,
      is_goods_received,
      quantity_type,
      quantity_per_box,
      xcoord,
      ycoord,
      batches,
    },
    {
      headers: {
        Authorization: "Bearer " + obj,
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
      },
    },
  );
};

export const getMedicaitionDataById = (obj, id, storeId) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + `/storewise/medicationall/${id}`;

  return axios.get(url, {
    params: {
      store_id: storeId,
    },
    headers: {
      "Content-Type": "application/json",
      "X-Request-ID": "124",
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: "Bearer " + obj,
    },
  });
};
export const EditPickUpOrder = (obj, id, payload) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/" + id;
  return axios
    .put(url, payload, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const createOrder = (obj, orderPayload) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders";
  return axios
    .post(url, orderPayload, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const getBatchNumberByMedicine = (obj, batchNumber, store_id) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + `/medication-batch-search`;

  return axios.get(url, {
    params: {
      batch_no: batchNumber,
      store_id: store_id,
    },
    headers: {
      "Content-Type": "application/json",
      "X-Request-ID": "124",
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: "Bearer " + obj,
    },
  });
};

export const getBatchNumberByAllMedicine = (obj, batchNumber) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + `/medications/batches/all`;

  return axios.get(url, {
    params: {
      batch_no: batchNumber,
    },
    headers: {
      "Content-Type": "application/json",
      "X-Request-ID": "124",
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: "Bearer " + obj,
    },
  });
};
export const getAllGenericName = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/medication-generic-names", {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};

export const searchMedicationForManualGrn = (title, obj) => {
  let url = "";

  url = `${process.env.REACT_APP_NOT_SECRET_CODE}/medications-all?search_medication=${title}`;

  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const getAllmedicationDataByBatchNumber = (obj, batchNumber, mediId) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + `/medication-batch-search-all`;

  return axios.get(url, {
    params: {
      batch_no: batchNumber,
      med_id: mediId,
    },
    headers: {
      "Content-Type": "application/json",
      "X-Request-ID": "124",
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: "Bearer " + obj,
    },
  });
};
export const getMedicationDataWarehouseWise = (
  obj,
  search_medication,
  storeId,
) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE + `/medication-store-wise-search`;

  return axios.get(url, {
    params: {
      search_medication: search_medication,
      store_id: storeId,
    },
    headers: {
      "Content-Type": "application/json",
      "X-Request-ID": "124",
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: "Bearer " + obj,
    },
  });
};

export const searchMedicationById = (obj, mediId) => {
  const url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    `/medication-search-by-id/${mediId}`;

  return axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      "X-Request-ID": "124",
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: "Bearer " + obj,
    },
  });
};
export const checkFirstOrder = (subscriberId, orderId, obj) => {
  const url = process.env.REACT_APP_NOT_SECRET_CODE + `/check-first-order`;

  return axios.get(url, {
    params: {
      lead_id: subscriberId,
      order_id: orderId,
    },
    headers: {
      "Content-Type": "application/json",
      "X-Request-ID": "124",
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: "Bearer " + obj,
    },
  });
};

// export const getAllAuthorizationDataByUserRole = (obj, roleId) => {
//   return axios
//     .get(
//       `${process.env.REACT_APP_NOT_SECRET_CODE}/check-released-stock/${roleId}`,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           "X-Request-ID": "124",
//           "X-Country-Code": "BD",
//           "X-Client-Name": "WEBSITE",
//           "X-Client-Version": "123",
//           Authorization: "Bearer " + obj,
//         },
//       },
//     )
//     .then((res) => res.data)
//     .catch((err) => {
//       console.error("Error fetching packages:", err.response || err);
//       throw err;
//     });
// };
export const getStoreWiseWarehouse = (countryCode, obj, type = "") => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        `/pharmacies?country=${countryCode}&type=${type}`,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      // console.log(res.data);
      return res.data;
    });
};
export const uploadOrderDocument = (obj, payload) => {
  let url = process.env.REACT_APP_NOT_SECRET_CODE + "/upload/order-documents";
  return axios
    .post(url, payload, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};

export const deleteOrderDocument = (id, obj) => {
  return axios
    .delete(
      process.env.REACT_APP_NOT_SECRET_CODE + "/delete/order-documents/" + id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
      // console.log(res);
      // window.location.href="#/admin/medication-category";
    })
    .catch((err) => {
      console.log(err);
    });
};
